"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModalBXsU9PJPGdHkA5xZcxCesE171320094Screen = ModalBXsU9PJPGdHkA5xZcxCesE171320094Screen;
var _materialSymbols = require("@design/icons/material-symbols");
var _avatar = require("@design/ui/avatar");
var _modalBXsU9PJPGdHkA5xZcxCesE = require("./modal-bXsU9PJPGdHkA5xZcxCesE-1713-20094.wiring");
var _jsxRuntime = require("react/jsx-runtime");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function ModalBXsU9PJPGdHkA5xZcxCesE171320094Screen() {
  var _w$modalHeaderContent, _w$modalContent, _w$tableSlot, _w$avatarShowBadge, _w$profileCardName, _w$profileCardBody, _w$avatarShowBadge2, _w$profileCardName2, _w$profileCardBody2, _w$avatarShowBadge3, _w$profileCardName3, _w$profileCardBody3, _w$avatarShowBadge4, _w$profileCardName4, _w$profileCardBody4, _w$selectShowIcon, _w$selectPlaceholder, _w$selectShowIcon2, _w$selectPlaceholder2, _w$selectShowIcon3, _w$selectPlaceholder3, _w$selectShowIcon4, _w$selectPlaceholder4, _w$tableSlot2, _w$avatarFallbackText, _w$avatarShowBadge5, _w$profileCardName5, _w$profileCardBody5, _w$avatarFallbackText2, _w$avatarShowBadge6, _w$profileCardName6, _w$profileCardBody6, _w$avatarFallbackText3, _w$avatarShowBadge7, _w$profileCardName7, _w$profileCardBody7, _w$avatarFallbackText4, _w$avatarShowBadge8, _w$profileCardName8, _w$profileCardBody8, _w$avatarFallbackText5, _w$avatarShowBadge9, _w$profileCardName9, _w$profileCardBody9, _w$avatarFallbackText6, _w$avatarShowBadge0, _w$profileCardName0, _w$profileCardBody0, _w$avatarFallbackText7, _w$avatarShowBadge1, _w$profileCardName1, _w$profileCardBody1, _w$selectShowIcon5, _w$selectPlaceholder5, _w$selectShowIcon6, _w$selectPlaceholder6, _w$selectShowIcon7, _w$selectPlaceholder7, _w$selectShowIcon8, _w$selectPlaceholder8, _w$selectShowIcon9, _w$selectPlaceholder9, _w$selectShowIcon0, _w$selectPlaceholder0, _w$selectShowIcon1, _w$selectPlaceholder1, _w$selectShowIcon10, _w$selectPlaceholder10, _w$selectShowIcon11, _w$selectPlaceholder11, _w$selectShowIcon12, _w$selectPlaceholder12, _w$selectShowIcon13, _w$selectPlaceholder13, _w$selectShowIcon14, _w$selectPlaceholder14, _w$selectShowIcon15, _w$selectPlaceholder15, _w$selectShowIcon16, _w$selectPlaceholder16, _w$selectShowIcon17, _w$selectPlaceholder17, _w$avatarFallbackText8, _w$avatarShowBadge10, _w$profileCardName10, _w$profileCardBody10, _w$avatarFallbackText9, _w$avatarShowBadge11, _w$profileCardName11, _w$profileCardBody11, _w$avatarFallbackText0, _w$avatarShowBadge12, _w$profileCardName12, _w$profileCardBody12, _w$avatarFallbackText1, _w$avatarShowBadge13, _w$profileCardName13, _w$profileCardBody13, _w$avatarFallbackText10, _w$avatarShowBadge14, _w$profileCardName14, _w$profileCardBody14, _w$avatarFallbackText11, _w$avatarShowBadge15, _w$profileCardName15, _w$profileCardBody15, _w$avatarFallbackText12, _w$avatarShowBadge16, _w$profileCardName16, _w$profileCardBody16, _w$avatarFallbackText13, _w$avatarShowBadge17, _w$profileCardName17, _w$profileCardBody17;
  var w = (0, _modalBXsU9PJPGdHkA5xZcxCesE.useWiring)();
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    style: {
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
      width: "600px",
      maxWidth: "800px",
      maxHeight: "800px",
      backgroundColor: "rgba(253, 253, 252, 1)",
      borderRadius: "8px"
    },
    "data-sentry-component": "ModalBXsU9PJPGdHkA5xZcxCesE171320094Screen",
    "data-sentry-source-file": "modal-bXsU9PJPGdHkA5xZcxCesE-1713-20094.tsx",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      style: {
        display: "flex",
        flexDirection: "row",
        gap: "16px",
        alignItems: "flex-start",
        padding: "16px 16px 16px 16px",
        alignSelf: "stretch"
      },
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        style: {
          display: "flex",
          flexDirection: "column",
          gap: "8px",
          justifyContent: "center",
          alignItems: "flex-start",
          flexGrow: "1",
          flexBasis: "0",
          minWidth: "0"
        },
        children: (_w$modalHeaderContent = w.modalHeaderContent) !== null && _w$modalHeaderContent !== void 0 ? _w$modalHeaderContent : /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            style: {
              display: "flex",
              flexDirection: "row",
              gap: "16px",
              alignItems: "center",
              alignSelf: "stretch"
            },
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
              src: "data:image/svg+xml,%3Csvg%20width%3D%2220%22%20height%3D%2220%22%20viewBox%3D%220%200%2020%2020%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%3Cpath%20d%3D%22M5.60912%209.29889H15.9827C16.1768%209.29889%2016.3392%209.36548%2016.4701%209.49865C16.6011%209.63167%2016.6666%209.79683%2016.6666%209.99412C16.6666%2010.1914%2016.6011%2010.3566%2016.4701%2010.4896C16.3392%2010.6228%2016.1768%2010.6893%2015.9827%2010.6893H5.60912L10.3225%2015.4811C10.458%2015.6189%2010.525%2015.7802%2010.5233%2015.9649C10.5215%2016.1497%2010.4499%2016.314%2010.3086%2016.4578C10.1671%2016.5921%2010.0069%2016.6616%209.82804%2016.6664C9.64918%2016.6712%209.489%2016.6017%209.34752%2016.4578L3.56645%2010.5807C3.48104%2010.4938%203.42086%2010.4023%203.38591%2010.306C3.3508%2010.2098%203.33325%2010.1058%203.33325%209.99412C3.33325%209.88242%203.3508%209.77844%203.38591%209.68219C3.42086%209.58594%203.48104%209.49441%203.56645%209.40758L9.34752%203.53039C9.47381%203.402%209.63018%203.33634%209.81665%203.33341C10.0031%203.33047%2010.1671%203.39613%2010.3086%203.53039C10.4499%203.67422%2010.5206%203.83938%2010.5206%204.02585C10.5206%204.21248%2010.4499%204.37771%2010.3086%204.52155L5.60912%209.29889Z%22%20fill%3D%22%231C1917%22%2F%3E%0A%3C%2Fsvg%3E",
              alt: "Icon/Arrow Left",
              style: {
                width: "20px",
                maxWidth: "100%",
                height: "20px"
              }
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              style: {
                color: "rgba(28, 25, 23, 1)",
                fontFamily: "Inter",
                fontSize: "16px",
                fontWeight: "500",
                lineHeight: "24px"
              },
              children: "Who has accses"
            })]
          })
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.CloseIcon, _objectSpread(_objectSpread({}, w.close), {}, {
        "data-sentry-element": "CloseIcon",
        "data-sentry-source-file": "modal-bXsU9PJPGdHkA5xZcxCesE-1713-20094.tsx"
      }))]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      style: {
        display: "flex",
        flexDirection: "column",
        gap: "32px",
        alignItems: "flex-start",
        padding: "0px 24px 24px 24px",
        alignSelf: "stretch",
        flexGrow: "1",
        flexBasis: "auto",
        minHeight: "0",
        overflowY: "auto"
      },
      children: (_w$modalContent = w.modalContent) !== null && _w$modalContent !== void 0 ? _w$modalContent : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          style: {
            display: "flex",
            flexDirection: "column",
            gap: "4px",
            alignItems: "flex-start",
            alignSelf: "stretch"
          },
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            style: {
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              alignSelf: "stretch"
            },
            children: (_w$tableSlot = w.tableSlot) !== null && _w$tableSlot !== void 0 ? _w$tableSlot : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                style: {
                  color: "rgba(142, 138, 131, 1)",
                  fontFamily: "Inter",
                  fontSize: "12px",
                  fontWeight: "400",
                  lineHeight: "16px",
                  letterSpacing: "0.12px"
                },
                children: "Teams"
              }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                style: {
                  display: "grid",
                  gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
                  alignSelf: "stretch"
                },
                children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                  style: {
                    display: "flex",
                    flexDirection: "row",
                    gap: "8px",
                    alignItems: "center",
                    padding: "8px 8px 8px 8px"
                  },
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_avatar.Avatar, _objectSpread(_objectSpread({}, w.avatar), {}, {
                    size: "default",
                    "data-variant": "icon",
                    children: [((_w$avatarShowBadge = w.avatarShowBadge) !== null && _w$avatarShowBadge !== void 0 ? _w$avatarShowBadge : false) ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_avatar.AvatarBadge, _objectSpread(_objectSpread({}, w.avatarBadge), {}, {
                      "data-type": "color"
                    })) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
                      src: "data:image/svg+xml,%3Csvg%20width%3D%2216%22%20height%3D%2216%22%20viewBox%3D%220%200%2016%2016%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%3Cmask%20id%3D%22mask0_0_204%22%20style%3D%22mask-type%3Aalpha%22%20maskUnits%3D%22userSpaceOnUse%22%20x%3D%220%22%20y%3D%220%22%20width%3D%2216%22%20height%3D%2216%22%3E%0A%3Crect%20width%3D%2216%22%20height%3D%2216%22%20fill%3D%22%23D9D9D9%22%2F%3E%0A%3C%2Fmask%3E%0A%3Cg%20mask%3D%22url(%23mask0_0_204)%22%3E%0A%3Cpath%20d%3D%22M1.19873%2011.3897C1.19873%2011.0461%201.2874%2010.7395%201.46473%2010.4698C1.64206%2010.2002%201.87901%209.99056%202.17556%209.84101C2.8089%209.53078%203.44584%209.29167%204.0864%209.12367C4.72706%208.95579%205.43112%208.87184%206.19856%208.87184C6.96612%208.87184%207.67018%208.95579%208.31073%209.12367C8.9514%209.29167%209.5884%209.53078%2010.2217%209.84101C10.5183%209.99056%2010.7552%2010.2002%2010.9326%2010.4698C11.1099%2010.7395%2011.1986%2011.0461%2011.1986%2011.3897V11.859C11.1986%2012.1273%2011.1001%2012.3632%2010.9031%2012.5667C10.7061%2012.7701%2010.467%2012.8718%2010.1857%2012.8718H2.2114C1.93029%2012.8718%201.69123%2012.7733%201.49423%2012.5763C1.29723%2012.3792%201.19873%2012.1401%201.19873%2011.859V11.3897ZM12.2742%2012.8718C12.358%2012.7188%2012.4219%2012.5562%2012.4659%2012.384C12.5099%2012.2118%2012.5319%2012.0368%2012.5319%2011.859V11.3077C12.5319%2010.8701%2012.4247%2010.4531%2012.2102%2010.0565C11.9957%209.65984%2011.6918%209.31967%2011.2986%209.03601C11.7456%209.10267%2012.17%209.20584%2012.5717%209.34551C12.9734%209.48528%2013.3567%209.65045%2013.7217%209.84101C14.0662%2010.0248%2014.3322%2010.241%2014.5197%2010.4897C14.7073%2010.7385%2014.8011%2011.0111%2014.8011%2011.3077V11.859C14.8011%2012.1401%2014.7026%2012.3792%2014.5056%2012.5763C14.3086%2012.7733%2014.0695%2012.8718%2013.7884%2012.8718H12.2742ZM4.54923%207.11084C4.09334%206.65495%203.8654%206.10517%203.8654%205.46151C3.8654%204.81795%204.09334%204.26817%204.54923%203.81217C5.00523%203.35617%205.55501%203.12817%206.19856%203.12817C6.84223%203.12817%207.39201%203.35617%207.8479%203.81217C8.3039%204.26817%208.5319%204.81795%208.5319%205.46151C8.5319%206.10517%208.3039%206.65495%207.8479%207.11084C7.39201%207.56684%206.84223%207.79484%206.19856%207.79484C5.55501%207.79484%205.00523%207.56684%204.54923%207.11084ZM11.2711%207.11084C10.8151%207.56684%2010.2653%207.79484%209.62173%207.79484C9.54651%207.79484%209.45079%207.78628%209.33456%207.76917C9.21823%207.75206%209.12251%207.73328%209.0474%207.71284C9.30884%207.39573%209.51051%207.04506%209.6524%206.66084C9.79429%206.27673%209.86523%205.87695%209.86523%205.46151C9.86523%205.04617%209.79323%204.64745%209.64923%204.26534C9.50523%203.88334%209.30462%203.53167%209.0474%203.21034C9.14306%203.17612%209.23879%203.1539%209.33456%203.14367C9.43023%203.13334%209.52595%203.12817%209.62173%203.12817C10.2653%203.12817%2010.8151%203.35617%2011.2711%203.81217C11.727%204.26817%2011.9549%204.81795%2011.9549%205.46151C11.9549%206.10517%2011.727%206.65495%2011.2711%207.11084Z%22%20fill%3D%22%238E8A83%22%2F%3E%0A%3C%2Fg%3E%0A%3C%2Fsvg%3E",
                      alt: "Icon/group",
                      style: {
                        width: "16px",
                        maxWidth: "100%",
                        height: "16px"
                      }
                    })]
                  })), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                    style: {
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "flex-start"
                    },
                    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                      style: {
                        display: "flex",
                        flexDirection: "row",
                        gap: "4px",
                        alignItems: "center",
                        alignSelf: "stretch"
                      },
                      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                        style: {
                          color: "rgba(28, 25, 23, 1)",
                          fontFamily: "Inter",
                          fontSize: "14px",
                          fontWeight: "500",
                          lineHeight: "20px"
                        },
                        children: (_w$profileCardName = w.profileCardName) !== null && _w$profileCardName !== void 0 ? _w$profileCardName : "Privacy team"
                      })
                    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                      style: {
                        alignSelf: "stretch",
                        color: "rgba(142, 138, 131, 1)",
                        fontFamily: "Inter",
                        fontSize: "12px",
                        fontWeight: "400",
                        lineHeight: "16px",
                        letterSpacing: "0.12px"
                      },
                      children: (_w$profileCardBody = w.profileCardBody) !== null && _w$profileCardBody !== void 0 ? _w$profileCardBody : "12 team members"
                    })]
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                  style: {
                    display: "flex",
                    flexDirection: "row",
                    gap: "8px",
                    alignItems: "center",
                    padding: "8px 8px 8px 8px"
                  },
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_avatar.Avatar, _objectSpread(_objectSpread({}, w.avatar2), {}, {
                    size: "default",
                    "data-variant": "icon",
                    children: [((_w$avatarShowBadge2 = w.avatarShowBadge2) !== null && _w$avatarShowBadge2 !== void 0 ? _w$avatarShowBadge2 : false) ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_avatar.AvatarBadge, _objectSpread(_objectSpread({}, w.avatarBadge2), {}, {
                      "data-type": "color"
                    })) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
                      src: "data:image/svg+xml,%3Csvg%20width%3D%2216%22%20height%3D%2216%22%20viewBox%3D%220%200%2016%2016%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%3Cmask%20id%3D%22mask0_0_214%22%20style%3D%22mask-type%3Aalpha%22%20maskUnits%3D%22userSpaceOnUse%22%20x%3D%220%22%20y%3D%220%22%20width%3D%2216%22%20height%3D%2216%22%3E%0A%3Crect%20width%3D%2216%22%20height%3D%2216%22%20fill%3D%22%23D9D9D9%22%2F%3E%0A%3C%2Fmask%3E%0A%3Cg%20mask%3D%22url(%23mask0_0_214)%22%3E%0A%3Cpath%20d%3D%22M1.19873%2011.3897C1.19873%2011.0461%201.2874%2010.7395%201.46473%2010.4698C1.64206%2010.2002%201.87901%209.99056%202.17556%209.84101C2.8089%209.53078%203.44584%209.29167%204.0864%209.12367C4.72706%208.95579%205.43112%208.87184%206.19856%208.87184C6.96612%208.87184%207.67018%208.95579%208.31073%209.12367C8.9514%209.29167%209.5884%209.53078%2010.2217%209.84101C10.5183%209.99056%2010.7552%2010.2002%2010.9326%2010.4698C11.1099%2010.7395%2011.1986%2011.0461%2011.1986%2011.3897V11.859C11.1986%2012.1273%2011.1001%2012.3632%2010.9031%2012.5667C10.7061%2012.7701%2010.467%2012.8718%2010.1857%2012.8718H2.2114C1.93029%2012.8718%201.69123%2012.7733%201.49423%2012.5763C1.29723%2012.3792%201.19873%2012.1401%201.19873%2011.859V11.3897ZM12.2742%2012.8718C12.358%2012.7188%2012.4219%2012.5562%2012.4659%2012.384C12.5099%2012.2118%2012.5319%2012.0368%2012.5319%2011.859V11.3077C12.5319%2010.8701%2012.4247%2010.4531%2012.2102%2010.0565C11.9957%209.65984%2011.6918%209.31967%2011.2986%209.03601C11.7456%209.10267%2012.17%209.20584%2012.5717%209.34551C12.9734%209.48528%2013.3567%209.65045%2013.7217%209.84101C14.0662%2010.0248%2014.3322%2010.241%2014.5197%2010.4897C14.7073%2010.7385%2014.8011%2011.0111%2014.8011%2011.3077V11.859C14.8011%2012.1401%2014.7026%2012.3792%2014.5056%2012.5763C14.3086%2012.7733%2014.0695%2012.8718%2013.7884%2012.8718H12.2742ZM4.54923%207.11084C4.09334%206.65495%203.8654%206.10517%203.8654%205.46151C3.8654%204.81795%204.09334%204.26817%204.54923%203.81217C5.00523%203.35617%205.55501%203.12817%206.19856%203.12817C6.84223%203.12817%207.39201%203.35617%207.8479%203.81217C8.3039%204.26817%208.5319%204.81795%208.5319%205.46151C8.5319%206.10517%208.3039%206.65495%207.8479%207.11084C7.39201%207.56684%206.84223%207.79484%206.19856%207.79484C5.55501%207.79484%205.00523%207.56684%204.54923%207.11084ZM11.2711%207.11084C10.8151%207.56684%2010.2653%207.79484%209.62173%207.79484C9.54651%207.79484%209.45079%207.78628%209.33456%207.76917C9.21823%207.75206%209.12251%207.73328%209.0474%207.71284C9.30884%207.39573%209.51051%207.04506%209.6524%206.66084C9.79429%206.27673%209.86523%205.87695%209.86523%205.46151C9.86523%205.04617%209.79323%204.64745%209.64923%204.26534C9.50523%203.88334%209.30462%203.53167%209.0474%203.21034C9.14306%203.17612%209.23879%203.1539%209.33456%203.14367C9.43023%203.13334%209.52595%203.12817%209.62173%203.12817C10.2653%203.12817%2010.8151%203.35617%2011.2711%203.81217C11.727%204.26817%2011.9549%204.81795%2011.9549%205.46151C11.9549%206.10517%2011.727%206.65495%2011.2711%207.11084Z%22%20fill%3D%22%238E8A83%22%2F%3E%0A%3C%2Fg%3E%0A%3C%2Fsvg%3E",
                      alt: "Icon/group",
                      style: {
                        width: "16px",
                        maxWidth: "100%",
                        height: "16px"
                      }
                    })]
                  })), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                    style: {
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "flex-start"
                    },
                    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                      style: {
                        display: "flex",
                        flexDirection: "row",
                        gap: "4px",
                        alignItems: "center",
                        alignSelf: "stretch"
                      },
                      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                        style: {
                          color: "rgba(28, 25, 23, 1)",
                          fontFamily: "Inter",
                          fontSize: "14px",
                          fontWeight: "500",
                          lineHeight: "20px"
                        },
                        children: (_w$profileCardName2 = w.profileCardName2) !== null && _w$profileCardName2 !== void 0 ? _w$profileCardName2 : "Privacy team"
                      })
                    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                      style: {
                        alignSelf: "stretch",
                        color: "rgba(142, 138, 131, 1)",
                        fontFamily: "Inter",
                        fontSize: "12px",
                        fontWeight: "400",
                        lineHeight: "16px",
                        letterSpacing: "0.12px"
                      },
                      children: (_w$profileCardBody2 = w.profileCardBody2) !== null && _w$profileCardBody2 !== void 0 ? _w$profileCardBody2 : "12 team members"
                    })]
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                  style: {
                    display: "flex",
                    flexDirection: "row",
                    gap: "8px",
                    alignItems: "center",
                    padding: "8px 8px 8px 8px"
                  },
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_avatar.Avatar, _objectSpread(_objectSpread({}, w.avatar3), {}, {
                    size: "default",
                    "data-variant": "icon",
                    children: [((_w$avatarShowBadge3 = w.avatarShowBadge3) !== null && _w$avatarShowBadge3 !== void 0 ? _w$avatarShowBadge3 : false) ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_avatar.AvatarBadge, _objectSpread(_objectSpread({}, w.avatarBadge3), {}, {
                      "data-type": "color"
                    })) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
                      src: "data:image/svg+xml,%3Csvg%20width%3D%2216%22%20height%3D%2216%22%20viewBox%3D%220%200%2016%2016%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%3Cmask%20id%3D%22mask0_0_224%22%20style%3D%22mask-type%3Aalpha%22%20maskUnits%3D%22userSpaceOnUse%22%20x%3D%220%22%20y%3D%220%22%20width%3D%2216%22%20height%3D%2216%22%3E%0A%3Crect%20width%3D%2216%22%20height%3D%2216%22%20fill%3D%22%23D9D9D9%22%2F%3E%0A%3C%2Fmask%3E%0A%3Cg%20mask%3D%22url(%23mask0_0_224)%22%3E%0A%3Cpath%20d%3D%22M1.19873%2011.3897C1.19873%2011.0461%201.2874%2010.7395%201.46473%2010.4698C1.64206%2010.2002%201.87901%209.99056%202.17556%209.84101C2.8089%209.53078%203.44584%209.29167%204.0864%209.12367C4.72706%208.95579%205.43112%208.87184%206.19856%208.87184C6.96612%208.87184%207.67018%208.95579%208.31073%209.12367C8.9514%209.29167%209.5884%209.53078%2010.2217%209.84101C10.5183%209.99056%2010.7552%2010.2002%2010.9326%2010.4698C11.1099%2010.7395%2011.1986%2011.0461%2011.1986%2011.3897V11.859C11.1986%2012.1273%2011.1001%2012.3632%2010.9031%2012.5667C10.7061%2012.7701%2010.467%2012.8718%2010.1857%2012.8718H2.2114C1.93029%2012.8718%201.69123%2012.7733%201.49423%2012.5763C1.29723%2012.3792%201.19873%2012.1401%201.19873%2011.859V11.3897ZM12.2742%2012.8718C12.358%2012.7188%2012.4219%2012.5562%2012.4659%2012.384C12.5099%2012.2118%2012.5319%2012.0368%2012.5319%2011.859V11.3077C12.5319%2010.8701%2012.4247%2010.4531%2012.2102%2010.0565C11.9957%209.65984%2011.6918%209.31967%2011.2986%209.03601C11.7456%209.10267%2012.17%209.20584%2012.5717%209.34551C12.9734%209.48528%2013.3567%209.65045%2013.7217%209.84101C14.0662%2010.0248%2014.3322%2010.241%2014.5197%2010.4897C14.7073%2010.7385%2014.8011%2011.0111%2014.8011%2011.3077V11.859C14.8011%2012.1401%2014.7026%2012.3792%2014.5056%2012.5763C14.3086%2012.7733%2014.0695%2012.8718%2013.7884%2012.8718H12.2742ZM4.54923%207.11084C4.09334%206.65495%203.8654%206.10517%203.8654%205.46151C3.8654%204.81795%204.09334%204.26817%204.54923%203.81217C5.00523%203.35617%205.55501%203.12817%206.19856%203.12817C6.84223%203.12817%207.39201%203.35617%207.8479%203.81217C8.3039%204.26817%208.5319%204.81795%208.5319%205.46151C8.5319%206.10517%208.3039%206.65495%207.8479%207.11084C7.39201%207.56684%206.84223%207.79484%206.19856%207.79484C5.55501%207.79484%205.00523%207.56684%204.54923%207.11084ZM11.2711%207.11084C10.8151%207.56684%2010.2653%207.79484%209.62173%207.79484C9.54651%207.79484%209.45079%207.78628%209.33456%207.76917C9.21823%207.75206%209.12251%207.73328%209.0474%207.71284C9.30884%207.39573%209.51051%207.04506%209.6524%206.66084C9.79429%206.27673%209.86523%205.87695%209.86523%205.46151C9.86523%205.04617%209.79323%204.64745%209.64923%204.26534C9.50523%203.88334%209.30462%203.53167%209.0474%203.21034C9.14306%203.17612%209.23879%203.1539%209.33456%203.14367C9.43023%203.13334%209.52595%203.12817%209.62173%203.12817C10.2653%203.12817%2010.8151%203.35617%2011.2711%203.81217C11.727%204.26817%2011.9549%204.81795%2011.9549%205.46151C11.9549%206.10517%2011.727%206.65495%2011.2711%207.11084Z%22%20fill%3D%22%238E8A83%22%2F%3E%0A%3C%2Fg%3E%0A%3C%2Fsvg%3E",
                      alt: "Icon/group",
                      style: {
                        width: "16px",
                        maxWidth: "100%",
                        height: "16px"
                      }
                    })]
                  })), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                    style: {
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "flex-start"
                    },
                    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                      style: {
                        display: "flex",
                        flexDirection: "row",
                        gap: "4px",
                        alignItems: "center",
                        alignSelf: "stretch"
                      },
                      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                        style: {
                          color: "rgba(28, 25, 23, 1)",
                          fontFamily: "Inter",
                          fontSize: "14px",
                          fontWeight: "500",
                          lineHeight: "20px"
                        },
                        children: (_w$profileCardName3 = w.profileCardName3) !== null && _w$profileCardName3 !== void 0 ? _w$profileCardName3 : "Privacy team"
                      })
                    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                      style: {
                        alignSelf: "stretch",
                        color: "rgba(142, 138, 131, 1)",
                        fontFamily: "Inter",
                        fontSize: "12px",
                        fontWeight: "400",
                        lineHeight: "16px",
                        letterSpacing: "0.12px"
                      },
                      children: (_w$profileCardBody3 = w.profileCardBody3) !== null && _w$profileCardBody3 !== void 0 ? _w$profileCardBody3 : "12 team members"
                    })]
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                  style: {
                    display: "flex",
                    flexDirection: "row",
                    gap: "8px",
                    alignItems: "center",
                    padding: "8px 8px 8px 8px"
                  },
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_avatar.Avatar, _objectSpread(_objectSpread({}, w.avatar4), {}, {
                    size: "default",
                    "data-variant": "icon",
                    children: [((_w$avatarShowBadge4 = w.avatarShowBadge4) !== null && _w$avatarShowBadge4 !== void 0 ? _w$avatarShowBadge4 : false) ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_avatar.AvatarBadge, _objectSpread(_objectSpread({}, w.avatarBadge4), {}, {
                      "data-type": "color"
                    })) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
                      src: "data:image/svg+xml,%3Csvg%20width%3D%2216%22%20height%3D%2216%22%20viewBox%3D%220%200%2016%2016%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%3Cmask%20id%3D%22mask0_0_234%22%20style%3D%22mask-type%3Aalpha%22%20maskUnits%3D%22userSpaceOnUse%22%20x%3D%220%22%20y%3D%220%22%20width%3D%2216%22%20height%3D%2216%22%3E%0A%3Crect%20width%3D%2216%22%20height%3D%2216%22%20fill%3D%22%23D9D9D9%22%2F%3E%0A%3C%2Fmask%3E%0A%3Cg%20mask%3D%22url(%23mask0_0_234)%22%3E%0A%3Cpath%20d%3D%22M1.19873%2011.3897C1.19873%2011.0461%201.2874%2010.7395%201.46473%2010.4698C1.64206%2010.2002%201.87901%209.99056%202.17556%209.84101C2.8089%209.53078%203.44584%209.29167%204.0864%209.12367C4.72706%208.95579%205.43112%208.87184%206.19856%208.87184C6.96612%208.87184%207.67018%208.95579%208.31073%209.12367C8.9514%209.29167%209.5884%209.53078%2010.2217%209.84101C10.5183%209.99056%2010.7552%2010.2002%2010.9326%2010.4698C11.1099%2010.7395%2011.1986%2011.0461%2011.1986%2011.3897V11.859C11.1986%2012.1273%2011.1001%2012.3632%2010.9031%2012.5667C10.7061%2012.7701%2010.467%2012.8718%2010.1857%2012.8718H2.2114C1.93029%2012.8718%201.69123%2012.7733%201.49423%2012.5763C1.29723%2012.3792%201.19873%2012.1401%201.19873%2011.859V11.3897ZM12.2742%2012.8718C12.358%2012.7188%2012.4219%2012.5562%2012.4659%2012.384C12.5099%2012.2118%2012.5319%2012.0368%2012.5319%2011.859V11.3077C12.5319%2010.8701%2012.4247%2010.4531%2012.2102%2010.0565C11.9957%209.65984%2011.6918%209.31967%2011.2986%209.03601C11.7456%209.10267%2012.17%209.20584%2012.5717%209.34551C12.9734%209.48528%2013.3567%209.65045%2013.7217%209.84101C14.0662%2010.0248%2014.3322%2010.241%2014.5197%2010.4897C14.7073%2010.7385%2014.8011%2011.0111%2014.8011%2011.3077V11.859C14.8011%2012.1401%2014.7026%2012.3792%2014.5056%2012.5763C14.3086%2012.7733%2014.0695%2012.8718%2013.7884%2012.8718H12.2742ZM4.54923%207.11084C4.09334%206.65495%203.8654%206.10517%203.8654%205.46151C3.8654%204.81795%204.09334%204.26817%204.54923%203.81217C5.00523%203.35617%205.55501%203.12817%206.19856%203.12817C6.84223%203.12817%207.39201%203.35617%207.8479%203.81217C8.3039%204.26817%208.5319%204.81795%208.5319%205.46151C8.5319%206.10517%208.3039%206.65495%207.8479%207.11084C7.39201%207.56684%206.84223%207.79484%206.19856%207.79484C5.55501%207.79484%205.00523%207.56684%204.54923%207.11084ZM11.2711%207.11084C10.8151%207.56684%2010.2653%207.79484%209.62173%207.79484C9.54651%207.79484%209.45079%207.78628%209.33456%207.76917C9.21823%207.75206%209.12251%207.73328%209.0474%207.71284C9.30884%207.39573%209.51051%207.04506%209.6524%206.66084C9.79429%206.27673%209.86523%205.87695%209.86523%205.46151C9.86523%205.04617%209.79323%204.64745%209.64923%204.26534C9.50523%203.88334%209.30462%203.53167%209.0474%203.21034C9.14306%203.17612%209.23879%203.1539%209.33456%203.14367C9.43023%203.13334%209.52595%203.12817%209.62173%203.12817C10.2653%203.12817%2010.8151%203.35617%2011.2711%203.81217C11.727%204.26817%2011.9549%204.81795%2011.9549%205.46151C11.9549%206.10517%2011.727%206.65495%2011.2711%207.11084Z%22%20fill%3D%22%238E8A83%22%2F%3E%0A%3C%2Fg%3E%0A%3C%2Fsvg%3E",
                      alt: "Icon/group",
                      style: {
                        width: "16px",
                        maxWidth: "100%",
                        height: "16px"
                      }
                    })]
                  })), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                    style: {
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "flex-start"
                    },
                    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                      style: {
                        display: "flex",
                        flexDirection: "row",
                        gap: "4px",
                        alignItems: "center",
                        alignSelf: "stretch"
                      },
                      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                        style: {
                          color: "rgba(28, 25, 23, 1)",
                          fontFamily: "Inter",
                          fontSize: "14px",
                          fontWeight: "500",
                          lineHeight: "20px"
                        },
                        children: (_w$profileCardName4 = w.profileCardName4) !== null && _w$profileCardName4 !== void 0 ? _w$profileCardName4 : "Privacy team"
                      })
                    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                      style: {
                        alignSelf: "stretch",
                        color: "rgba(142, 138, 131, 1)",
                        fontFamily: "Inter",
                        fontSize: "12px",
                        fontWeight: "400",
                        lineHeight: "16px",
                        letterSpacing: "0.12px"
                      },
                      children: (_w$profileCardBody4 = w.profileCardBody4) !== null && _w$profileCardBody4 !== void 0 ? _w$profileCardBody4 : "12 team members"
                    })]
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                  style: {
                    display: "flex",
                    flexDirection: "row",
                    gap: "8px",
                    alignItems: "center",
                    padding: "8px 12px 8px 12px",
                    height: "36px",
                    maxWidth: "448px",
                    backgroundColor: "rgba(253, 253, 252, 1)",
                    borderRadius: "8px"
                  },
                  children: [((_w$selectShowIcon = w.selectShowIcon) !== null && _w$selectShowIcon !== void 0 ? _w$selectShowIcon : false) ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                    style: {
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "16px",
                      maxWidth: "100%",
                      height: "16px"
                    },
                    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                      style: {
                        alignSelf: "stretch",
                        flexGrow: "1",
                        flexBasis: "0",
                        minHeight: "0"
                      },
                      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                        style: {
                          backgroundColor: "rgba(217, 217, 217, 1)"
                        }
                      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                        style: {
                          backgroundColor: "rgba(142, 138, 131, 1)"
                        }
                      })]
                    })
                  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                    style: {
                      flexGrow: "1",
                      flexBasis: "auto",
                      minWidth: "0",
                      color: "rgba(28, 25, 23, 1)",
                      fontFamily: "Inter",
                      fontSize: "14px",
                      fontWeight: "400",
                      lineHeight: "20px"
                    },
                    children: (_w$selectPlaceholder = w.selectPlaceholder) !== null && _w$selectPlaceholder !== void 0 ? _w$selectPlaceholder : "Viewer"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
                    src: "data:image/svg+xml,%3Csvg%20width%3D%2216%22%20height%3D%2216%22%20viewBox%3D%220%200%2016%2016%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%3Cg%20clip-path%3D%22url(%23clip0_0_247)%22%3E%0A%3Cpath%20d%3D%22M4%206L8%2010L12%206%22%20stroke-width%3D%221.33%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%20stroke%3D%22%238E8A83%22%2F%3E%0A%3C%2Fg%3E%0A%3Cdefs%3E%0A%3CclipPath%20id%3D%22clip0_0_247%22%3E%0A%3Crect%20width%3D%2216%22%20height%3D%2216%22%20fill%3D%22white%22%2F%3E%0A%3C%2FclipPath%3E%0A%3C%2Fdefs%3E%0A%3C%2Fsvg%3E",
                    alt: "Icon Placeholder",
                    style: {
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "16px",
                      maxWidth: "100%",
                      height: "16px"
                    }
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                  style: {
                    display: "flex",
                    flexDirection: "row",
                    gap: "8px",
                    alignItems: "center",
                    padding: "8px 12px 8px 12px",
                    height: "36px",
                    maxWidth: "448px",
                    backgroundColor: "rgba(253, 253, 252, 1)",
                    borderRadius: "8px"
                  },
                  children: [((_w$selectShowIcon2 = w.selectShowIcon2) !== null && _w$selectShowIcon2 !== void 0 ? _w$selectShowIcon2 : false) ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                    style: {
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "16px",
                      maxWidth: "100%",
                      height: "16px"
                    },
                    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                      style: {
                        alignSelf: "stretch",
                        flexGrow: "1",
                        flexBasis: "0",
                        minHeight: "0"
                      },
                      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                        style: {
                          backgroundColor: "rgba(217, 217, 217, 1)"
                        }
                      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                        style: {
                          backgroundColor: "rgba(142, 138, 131, 1)"
                        }
                      })]
                    })
                  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                    style: {
                      flexGrow: "1",
                      flexBasis: "auto",
                      minWidth: "0",
                      color: "rgba(28, 25, 23, 1)",
                      fontFamily: "Inter",
                      fontSize: "14px",
                      fontWeight: "400",
                      lineHeight: "20px"
                    },
                    children: (_w$selectPlaceholder2 = w.selectPlaceholder2) !== null && _w$selectPlaceholder2 !== void 0 ? _w$selectPlaceholder2 : "Viewer"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
                    src: "data:image/svg+xml,%3Csvg%20width%3D%2216%22%20height%3D%2216%22%20viewBox%3D%220%200%2016%2016%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%3Cg%20clip-path%3D%22url(%23clip0_0_256)%22%3E%0A%3Cpath%20d%3D%22M4%206L8%2010L12%206%22%20stroke-width%3D%221.33%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%20stroke%3D%22%238E8A83%22%2F%3E%0A%3C%2Fg%3E%0A%3Cdefs%3E%0A%3CclipPath%20id%3D%22clip0_0_256%22%3E%0A%3Crect%20width%3D%2216%22%20height%3D%2216%22%20fill%3D%22white%22%2F%3E%0A%3C%2FclipPath%3E%0A%3C%2Fdefs%3E%0A%3C%2Fsvg%3E",
                    alt: "Icon Placeholder",
                    style: {
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "16px",
                      maxWidth: "100%",
                      height: "16px"
                    }
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                  style: {
                    display: "flex",
                    flexDirection: "row",
                    gap: "8px",
                    alignItems: "center",
                    padding: "8px 12px 8px 12px",
                    height: "36px",
                    maxWidth: "448px",
                    backgroundColor: "rgba(253, 253, 252, 1)",
                    borderRadius: "8px"
                  },
                  children: [((_w$selectShowIcon3 = w.selectShowIcon3) !== null && _w$selectShowIcon3 !== void 0 ? _w$selectShowIcon3 : false) ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                    style: {
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "16px",
                      maxWidth: "100%",
                      height: "16px"
                    },
                    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                      style: {
                        alignSelf: "stretch",
                        flexGrow: "1",
                        flexBasis: "0",
                        minHeight: "0"
                      },
                      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                        style: {
                          backgroundColor: "rgba(217, 217, 217, 1)"
                        }
                      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                        style: {
                          backgroundColor: "rgba(142, 138, 131, 1)"
                        }
                      })]
                    })
                  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                    style: {
                      flexGrow: "1",
                      flexBasis: "auto",
                      minWidth: "0",
                      color: "rgba(28, 25, 23, 1)",
                      fontFamily: "Inter",
                      fontSize: "14px",
                      fontWeight: "400",
                      lineHeight: "20px"
                    },
                    children: (_w$selectPlaceholder3 = w.selectPlaceholder3) !== null && _w$selectPlaceholder3 !== void 0 ? _w$selectPlaceholder3 : "Viewer"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
                    src: "data:image/svg+xml,%3Csvg%20width%3D%2216%22%20height%3D%2216%22%20viewBox%3D%220%200%2016%2016%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%3Cg%20clip-path%3D%22url(%23clip0_0_265)%22%3E%0A%3Cpath%20d%3D%22M4%206L8%2010L12%206%22%20stroke-width%3D%221.33%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%20stroke%3D%22%238E8A83%22%2F%3E%0A%3C%2Fg%3E%0A%3Cdefs%3E%0A%3CclipPath%20id%3D%22clip0_0_265%22%3E%0A%3Crect%20width%3D%2216%22%20height%3D%2216%22%20fill%3D%22white%22%2F%3E%0A%3C%2FclipPath%3E%0A%3C%2Fdefs%3E%0A%3C%2Fsvg%3E",
                    alt: "Icon Placeholder",
                    style: {
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "16px",
                      maxWidth: "100%",
                      height: "16px"
                    }
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                  style: {
                    display: "flex",
                    flexDirection: "row",
                    gap: "8px",
                    alignItems: "center",
                    padding: "8px 12px 8px 12px",
                    height: "36px",
                    maxWidth: "448px",
                    backgroundColor: "rgba(253, 253, 252, 1)",
                    borderRadius: "8px"
                  },
                  children: [((_w$selectShowIcon4 = w.selectShowIcon4) !== null && _w$selectShowIcon4 !== void 0 ? _w$selectShowIcon4 : false) ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                    style: {
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "16px",
                      maxWidth: "100%",
                      height: "16px"
                    },
                    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                      style: {
                        alignSelf: "stretch",
                        flexGrow: "1",
                        flexBasis: "0",
                        minHeight: "0"
                      },
                      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                        style: {
                          backgroundColor: "rgba(217, 217, 217, 1)"
                        }
                      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                        style: {
                          backgroundColor: "rgba(142, 138, 131, 1)"
                        }
                      })]
                    })
                  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                    style: {
                      flexGrow: "1",
                      flexBasis: "auto",
                      minWidth: "0",
                      color: "rgba(28, 25, 23, 1)",
                      fontFamily: "Inter",
                      fontSize: "14px",
                      fontWeight: "400",
                      lineHeight: "20px"
                    },
                    children: (_w$selectPlaceholder4 = w.selectPlaceholder4) !== null && _w$selectPlaceholder4 !== void 0 ? _w$selectPlaceholder4 : "Viewer"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
                    src: "data:image/svg+xml,%3Csvg%20width%3D%2216%22%20height%3D%2216%22%20viewBox%3D%220%200%2016%2016%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%3Cg%20clip-path%3D%22url(%23clip0_0_274)%22%3E%0A%3Cpath%20d%3D%22M4%206L8%2010L12%206%22%20stroke-width%3D%221.33%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%20stroke%3D%22%238E8A83%22%2F%3E%0A%3C%2Fg%3E%0A%3Cdefs%3E%0A%3CclipPath%20id%3D%22clip0_0_274%22%3E%0A%3Crect%20width%3D%2216%22%20height%3D%2216%22%20fill%3D%22white%22%2F%3E%0A%3C%2FclipPath%3E%0A%3C%2Fdefs%3E%0A%3C%2Fsvg%3E",
                    alt: "Icon Placeholder",
                    style: {
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "16px",
                      maxWidth: "100%",
                      height: "16px"
                    }
                  })]
                })]
              })]
            })
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          style: {
            display: "flex",
            flexDirection: "column",
            gap: "4px",
            alignItems: "flex-start",
            alignSelf: "stretch",
            flexGrow: "1",
            flexBasis: "0",
            minHeight: "0"
          },
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            style: {
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              alignSelf: "stretch",
              flexGrow: "1",
              flexBasis: "0",
              minHeight: "0"
            },
            children: (_w$tableSlot2 = w.tableSlot2) !== null && _w$tableSlot2 !== void 0 ? _w$tableSlot2 : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                style: {
                  color: "rgba(142, 138, 131, 1)",
                  fontFamily: "Inter",
                  fontSize: "12px",
                  fontWeight: "400",
                  lineHeight: "16px",
                  letterSpacing: "0.12px"
                },
                children: "Individuals"
              }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                style: {
                  display: "grid",
                  gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
                  alignSelf: "stretch"
                },
                children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                  style: {
                    display: "flex",
                    flexDirection: "row",
                    gap: "8px",
                    alignItems: "center",
                    padding: "8px 8px 8px 8px"
                  },
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_avatar.Avatar, _objectSpread(_objectSpread({}, w.avatar5), {}, {
                    size: "default",
                    "data-variant": "fallback",
                    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                      style: {
                        color: "rgba(63, 60, 56, 1)",
                        fontFamily: "Inter",
                        fontSize: "12px",
                        fontWeight: "400",
                        lineHeight: "20px",
                        textAlign: "center"
                      },
                      children: (_w$avatarFallbackText = w.avatarFallbackText) !== null && _w$avatarFallbackText !== void 0 ? _w$avatarFallbackText : "ST"
                    }), ((_w$avatarShowBadge5 = w.avatarShowBadge5) !== null && _w$avatarShowBadge5 !== void 0 ? _w$avatarShowBadge5 : false) ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_avatar.AvatarBadge, _objectSpread(_objectSpread({}, w.avatarBadge5), {}, {
                      "data-type": "color"
                    })) : null]
                  })), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                    style: {
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "flex-start"
                    },
                    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                      style: {
                        display: "flex",
                        flexDirection: "row",
                        gap: "4px",
                        alignItems: "center",
                        alignSelf: "stretch"
                      },
                      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                        style: {
                          color: "rgba(28, 25, 23, 1)",
                          fontFamily: "Inter",
                          fontSize: "14px",
                          fontWeight: "500",
                          lineHeight: "20px"
                        },
                        children: (_w$profileCardName5 = w.profileCardName5) !== null && _w$profileCardName5 !== void 0 ? _w$profileCardName5 : "Sophie Tan"
                      })
                    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                      style: {
                        alignSelf: "stretch",
                        color: "rgba(142, 138, 131, 1)",
                        fontFamily: "Inter",
                        fontSize: "12px",
                        fontWeight: "400",
                        lineHeight: "16px",
                        letterSpacing: "0.12px"
                      },
                      children: (_w$profileCardBody5 = w.profileCardBody5) !== null && _w$profileCardBody5 !== void 0 ? _w$profileCardBody5 : "sophie.tan@acme.com"
                    })]
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                  style: {
                    display: "flex",
                    flexDirection: "row",
                    gap: "8px",
                    alignItems: "center",
                    padding: "8px 8px 8px 8px"
                  },
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_avatar.Avatar, _objectSpread(_objectSpread({}, w.avatar6), {}, {
                    size: "default",
                    "data-variant": "fallback",
                    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                      style: {
                        color: "rgba(63, 60, 56, 1)",
                        fontFamily: "Inter",
                        fontSize: "12px",
                        fontWeight: "400",
                        lineHeight: "20px",
                        textAlign: "center"
                      },
                      children: (_w$avatarFallbackText2 = w.avatarFallbackText2) !== null && _w$avatarFallbackText2 !== void 0 ? _w$avatarFallbackText2 : "ST"
                    }), ((_w$avatarShowBadge6 = w.avatarShowBadge6) !== null && _w$avatarShowBadge6 !== void 0 ? _w$avatarShowBadge6 : false) ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_avatar.AvatarBadge, _objectSpread(_objectSpread({}, w.avatarBadge6), {}, {
                      "data-type": "color"
                    })) : null]
                  })), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                    style: {
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "flex-start"
                    },
                    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                      style: {
                        display: "flex",
                        flexDirection: "row",
                        gap: "4px",
                        alignItems: "center",
                        alignSelf: "stretch"
                      },
                      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                        style: {
                          color: "rgba(28, 25, 23, 1)",
                          fontFamily: "Inter",
                          fontSize: "14px",
                          fontWeight: "500",
                          lineHeight: "20px"
                        },
                        children: (_w$profileCardName6 = w.profileCardName6) !== null && _w$profileCardName6 !== void 0 ? _w$profileCardName6 : "Sophie Tan"
                      })
                    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                      style: {
                        alignSelf: "stretch",
                        color: "rgba(142, 138, 131, 1)",
                        fontFamily: "Inter",
                        fontSize: "12px",
                        fontWeight: "400",
                        lineHeight: "16px",
                        letterSpacing: "0.12px"
                      },
                      children: (_w$profileCardBody6 = w.profileCardBody6) !== null && _w$profileCardBody6 !== void 0 ? _w$profileCardBody6 : "sophie.tan@acme.com"
                    })]
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                  style: {
                    display: "flex",
                    flexDirection: "row",
                    gap: "8px",
                    alignItems: "center",
                    padding: "8px 8px 8px 8px"
                  },
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_avatar.Avatar, _objectSpread(_objectSpread({}, w.avatar7), {}, {
                    size: "default",
                    "data-variant": "fallback",
                    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                      style: {
                        color: "rgba(63, 60, 56, 1)",
                        fontFamily: "Inter",
                        fontSize: "12px",
                        fontWeight: "400",
                        lineHeight: "20px",
                        textAlign: "center"
                      },
                      children: (_w$avatarFallbackText3 = w.avatarFallbackText3) !== null && _w$avatarFallbackText3 !== void 0 ? _w$avatarFallbackText3 : "ST"
                    }), ((_w$avatarShowBadge7 = w.avatarShowBadge7) !== null && _w$avatarShowBadge7 !== void 0 ? _w$avatarShowBadge7 : false) ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_avatar.AvatarBadge, _objectSpread(_objectSpread({}, w.avatarBadge7), {}, {
                      "data-type": "color"
                    })) : null]
                  })), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                    style: {
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "flex-start"
                    },
                    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                      style: {
                        display: "flex",
                        flexDirection: "row",
                        gap: "4px",
                        alignItems: "center",
                        alignSelf: "stretch"
                      },
                      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                        style: {
                          color: "rgba(28, 25, 23, 1)",
                          fontFamily: "Inter",
                          fontSize: "14px",
                          fontWeight: "500",
                          lineHeight: "20px"
                        },
                        children: (_w$profileCardName7 = w.profileCardName7) !== null && _w$profileCardName7 !== void 0 ? _w$profileCardName7 : "Sophie Tan"
                      })
                    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                      style: {
                        alignSelf: "stretch",
                        color: "rgba(142, 138, 131, 1)",
                        fontFamily: "Inter",
                        fontSize: "12px",
                        fontWeight: "400",
                        lineHeight: "16px",
                        letterSpacing: "0.12px"
                      },
                      children: (_w$profileCardBody7 = w.profileCardBody7) !== null && _w$profileCardBody7 !== void 0 ? _w$profileCardBody7 : "sophie.tan@acme.com"
                    })]
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                  style: {
                    display: "flex",
                    flexDirection: "row",
                    gap: "8px",
                    alignItems: "center",
                    padding: "8px 8px 8px 8px"
                  },
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_avatar.Avatar, _objectSpread(_objectSpread({}, w.avatar8), {}, {
                    size: "default",
                    "data-variant": "fallback",
                    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                      style: {
                        color: "rgba(63, 60, 56, 1)",
                        fontFamily: "Inter",
                        fontSize: "12px",
                        fontWeight: "400",
                        lineHeight: "20px",
                        textAlign: "center"
                      },
                      children: (_w$avatarFallbackText4 = w.avatarFallbackText4) !== null && _w$avatarFallbackText4 !== void 0 ? _w$avatarFallbackText4 : "ST"
                    }), ((_w$avatarShowBadge8 = w.avatarShowBadge8) !== null && _w$avatarShowBadge8 !== void 0 ? _w$avatarShowBadge8 : false) ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_avatar.AvatarBadge, _objectSpread(_objectSpread({}, w.avatarBadge8), {}, {
                      "data-type": "color"
                    })) : null]
                  })), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                    style: {
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "flex-start"
                    },
                    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                      style: {
                        display: "flex",
                        flexDirection: "row",
                        gap: "4px",
                        alignItems: "center",
                        alignSelf: "stretch"
                      },
                      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                        style: {
                          color: "rgba(28, 25, 23, 1)",
                          fontFamily: "Inter",
                          fontSize: "14px",
                          fontWeight: "500",
                          lineHeight: "20px"
                        },
                        children: (_w$profileCardName8 = w.profileCardName8) !== null && _w$profileCardName8 !== void 0 ? _w$profileCardName8 : "Sophie Tan"
                      })
                    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                      style: {
                        alignSelf: "stretch",
                        color: "rgba(142, 138, 131, 1)",
                        fontFamily: "Inter",
                        fontSize: "12px",
                        fontWeight: "400",
                        lineHeight: "16px",
                        letterSpacing: "0.12px"
                      },
                      children: (_w$profileCardBody8 = w.profileCardBody8) !== null && _w$profileCardBody8 !== void 0 ? _w$profileCardBody8 : "sophie.tan@acme.com"
                    })]
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                  style: {
                    display: "flex",
                    flexDirection: "row",
                    gap: "8px",
                    alignItems: "center",
                    padding: "8px 8px 8px 8px"
                  },
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_avatar.Avatar, _objectSpread(_objectSpread({}, w.avatar9), {}, {
                    size: "default",
                    "data-variant": "fallback",
                    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                      style: {
                        color: "rgba(63, 60, 56, 1)",
                        fontFamily: "Inter",
                        fontSize: "12px",
                        fontWeight: "400",
                        lineHeight: "20px",
                        textAlign: "center"
                      },
                      children: (_w$avatarFallbackText5 = w.avatarFallbackText5) !== null && _w$avatarFallbackText5 !== void 0 ? _w$avatarFallbackText5 : "ST"
                    }), ((_w$avatarShowBadge9 = w.avatarShowBadge9) !== null && _w$avatarShowBadge9 !== void 0 ? _w$avatarShowBadge9 : false) ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_avatar.AvatarBadge, _objectSpread(_objectSpread({}, w.avatarBadge9), {}, {
                      "data-type": "color"
                    })) : null]
                  })), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                    style: {
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "flex-start"
                    },
                    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                      style: {
                        display: "flex",
                        flexDirection: "row",
                        gap: "4px",
                        alignItems: "center",
                        alignSelf: "stretch"
                      },
                      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                        style: {
                          color: "rgba(28, 25, 23, 1)",
                          fontFamily: "Inter",
                          fontSize: "14px",
                          fontWeight: "500",
                          lineHeight: "20px"
                        },
                        children: (_w$profileCardName9 = w.profileCardName9) !== null && _w$profileCardName9 !== void 0 ? _w$profileCardName9 : "Sophie Tan"
                      })
                    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                      style: {
                        alignSelf: "stretch",
                        color: "rgba(142, 138, 131, 1)",
                        fontFamily: "Inter",
                        fontSize: "12px",
                        fontWeight: "400",
                        lineHeight: "16px",
                        letterSpacing: "0.12px"
                      },
                      children: (_w$profileCardBody9 = w.profileCardBody9) !== null && _w$profileCardBody9 !== void 0 ? _w$profileCardBody9 : "sophie.tan@acme.com"
                    })]
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                  style: {
                    display: "flex",
                    flexDirection: "row",
                    gap: "8px",
                    alignItems: "center",
                    padding: "8px 8px 8px 8px"
                  },
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_avatar.Avatar, _objectSpread(_objectSpread({}, w.avatar10), {}, {
                    size: "default",
                    "data-variant": "fallback",
                    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                      style: {
                        color: "rgba(63, 60, 56, 1)",
                        fontFamily: "Inter",
                        fontSize: "12px",
                        fontWeight: "400",
                        lineHeight: "20px",
                        textAlign: "center"
                      },
                      children: (_w$avatarFallbackText6 = w.avatarFallbackText6) !== null && _w$avatarFallbackText6 !== void 0 ? _w$avatarFallbackText6 : "ST"
                    }), ((_w$avatarShowBadge0 = w.avatarShowBadge10) !== null && _w$avatarShowBadge0 !== void 0 ? _w$avatarShowBadge0 : false) ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_avatar.AvatarBadge, _objectSpread(_objectSpread({}, w.avatarBadge10), {}, {
                      "data-type": "color"
                    })) : null]
                  })), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                    style: {
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "flex-start"
                    },
                    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                      style: {
                        display: "flex",
                        flexDirection: "row",
                        gap: "4px",
                        alignItems: "center",
                        alignSelf: "stretch"
                      },
                      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                        style: {
                          color: "rgba(28, 25, 23, 1)",
                          fontFamily: "Inter",
                          fontSize: "14px",
                          fontWeight: "500",
                          lineHeight: "20px"
                        },
                        children: (_w$profileCardName0 = w.profileCardName10) !== null && _w$profileCardName0 !== void 0 ? _w$profileCardName0 : "Sophie Tan"
                      })
                    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                      style: {
                        alignSelf: "stretch",
                        color: "rgba(142, 138, 131, 1)",
                        fontFamily: "Inter",
                        fontSize: "12px",
                        fontWeight: "400",
                        lineHeight: "16px",
                        letterSpacing: "0.12px"
                      },
                      children: (_w$profileCardBody0 = w.profileCardBody10) !== null && _w$profileCardBody0 !== void 0 ? _w$profileCardBody0 : "sophie.tan@acme.com"
                    })]
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                  style: {
                    display: "flex",
                    flexDirection: "row",
                    gap: "8px",
                    alignItems: "center",
                    padding: "8px 8px 8px 8px"
                  },
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_avatar.Avatar, _objectSpread(_objectSpread({}, w.avatar11), {}, {
                    size: "default",
                    "data-variant": "fallback",
                    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                      style: {
                        color: "rgba(63, 60, 56, 1)",
                        fontFamily: "Inter",
                        fontSize: "12px",
                        fontWeight: "400",
                        lineHeight: "20px",
                        textAlign: "center"
                      },
                      children: (_w$avatarFallbackText7 = w.avatarFallbackText7) !== null && _w$avatarFallbackText7 !== void 0 ? _w$avatarFallbackText7 : "ST"
                    }), ((_w$avatarShowBadge1 = w.avatarShowBadge11) !== null && _w$avatarShowBadge1 !== void 0 ? _w$avatarShowBadge1 : false) ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_avatar.AvatarBadge, _objectSpread(_objectSpread({}, w.avatarBadge11), {}, {
                      "data-type": "color"
                    })) : null]
                  })), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                    style: {
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "flex-start"
                    },
                    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                      style: {
                        display: "flex",
                        flexDirection: "row",
                        gap: "4px",
                        alignItems: "center",
                        alignSelf: "stretch"
                      },
                      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                        style: {
                          color: "rgba(28, 25, 23, 1)",
                          fontFamily: "Inter",
                          fontSize: "14px",
                          fontWeight: "500",
                          lineHeight: "20px"
                        },
                        children: (_w$profileCardName1 = w.profileCardName11) !== null && _w$profileCardName1 !== void 0 ? _w$profileCardName1 : "Sophie Tan"
                      })
                    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                      style: {
                        alignSelf: "stretch",
                        color: "rgba(142, 138, 131, 1)",
                        fontFamily: "Inter",
                        fontSize: "12px",
                        fontWeight: "400",
                        lineHeight: "16px",
                        letterSpacing: "0.12px"
                      },
                      children: (_w$profileCardBody1 = w.profileCardBody11) !== null && _w$profileCardBody1 !== void 0 ? _w$profileCardBody1 : "sophie.tan@acme.com"
                    })]
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                  style: {
                    display: "flex",
                    flexDirection: "row",
                    gap: "8px",
                    alignItems: "center",
                    padding: "8px 12px 8px 12px",
                    height: "36px",
                    maxWidth: "448px",
                    backgroundColor: "rgba(253, 253, 252, 1)",
                    borderRadius: "8px"
                  },
                  children: [((_w$selectShowIcon5 = w.selectShowIcon5) !== null && _w$selectShowIcon5 !== void 0 ? _w$selectShowIcon5 : false) ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                    style: {
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "16px",
                      maxWidth: "100%",
                      height: "16px"
                    },
                    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                      style: {
                        alignSelf: "stretch",
                        flexGrow: "1",
                        flexBasis: "0",
                        minHeight: "0"
                      },
                      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                        style: {
                          backgroundColor: "rgba(217, 217, 217, 1)"
                        }
                      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                        style: {
                          backgroundColor: "rgba(142, 138, 131, 1)"
                        }
                      })]
                    })
                  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                    style: {
                      flexGrow: "1",
                      flexBasis: "auto",
                      minWidth: "0",
                      color: "rgba(28, 25, 23, 1)",
                      fontFamily: "Inter",
                      fontSize: "14px",
                      fontWeight: "400",
                      lineHeight: "20px"
                    },
                    children: (_w$selectPlaceholder5 = w.selectPlaceholder5) !== null && _w$selectPlaceholder5 !== void 0 ? _w$selectPlaceholder5 : "Viewer"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
                    src: "data:image/svg+xml,%3Csvg%20width%3D%2216%22%20height%3D%2216%22%20viewBox%3D%220%200%2016%2016%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%3Cg%20clip-path%3D%22url(%23clip0_0_826)%22%3E%0A%3Cpath%20d%3D%22M4%206L8%2010L12%206%22%20stroke-width%3D%221.33%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%20stroke%3D%22%238E8A83%22%2F%3E%0A%3C%2Fg%3E%0A%3Cdefs%3E%0A%3CclipPath%20id%3D%22clip0_0_826%22%3E%0A%3Crect%20width%3D%2216%22%20height%3D%2216%22%20fill%3D%22white%22%2F%3E%0A%3C%2FclipPath%3E%0A%3C%2Fdefs%3E%0A%3C%2Fsvg%3E",
                    alt: "Icon Placeholder",
                    style: {
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "16px",
                      maxWidth: "100%",
                      height: "16px"
                    }
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                  style: {
                    display: "flex",
                    flexDirection: "row",
                    gap: "8px",
                    alignItems: "center",
                    padding: "8px 12px 8px 12px",
                    height: "36px",
                    maxWidth: "448px",
                    backgroundColor: "rgba(253, 253, 252, 1)",
                    borderRadius: "8px"
                  },
                  children: [((_w$selectShowIcon6 = w.selectShowIcon6) !== null && _w$selectShowIcon6 !== void 0 ? _w$selectShowIcon6 : false) ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                    style: {
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "16px",
                      maxWidth: "100%",
                      height: "16px"
                    },
                    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                      style: {
                        alignSelf: "stretch",
                        flexGrow: "1",
                        flexBasis: "0",
                        minHeight: "0"
                      },
                      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                        style: {
                          backgroundColor: "rgba(217, 217, 217, 1)"
                        }
                      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                        style: {
                          backgroundColor: "rgba(142, 138, 131, 1)"
                        }
                      })]
                    })
                  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                    style: {
                      flexGrow: "1",
                      flexBasis: "auto",
                      minWidth: "0",
                      color: "rgba(28, 25, 23, 1)",
                      fontFamily: "Inter",
                      fontSize: "14px",
                      fontWeight: "400",
                      lineHeight: "20px"
                    },
                    children: (_w$selectPlaceholder6 = w.selectPlaceholder6) !== null && _w$selectPlaceholder6 !== void 0 ? _w$selectPlaceholder6 : "Editor"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
                    src: "data:image/svg+xml,%3Csvg%20width%3D%2216%22%20height%3D%2216%22%20viewBox%3D%220%200%2016%2016%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%3Cg%20clip-path%3D%22url(%23clip0_0_835)%22%3E%0A%3Cpath%20d%3D%22M4%206L8%2010L12%206%22%20stroke-width%3D%221.33%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%20stroke%3D%22%238E8A83%22%2F%3E%0A%3C%2Fg%3E%0A%3Cdefs%3E%0A%3CclipPath%20id%3D%22clip0_0_835%22%3E%0A%3Crect%20width%3D%2216%22%20height%3D%2216%22%20fill%3D%22white%22%2F%3E%0A%3C%2FclipPath%3E%0A%3C%2Fdefs%3E%0A%3C%2Fsvg%3E",
                    alt: "Icon Placeholder",
                    style: {
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "16px",
                      maxWidth: "100%",
                      height: "16px"
                    }
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                  style: {
                    display: "flex",
                    flexDirection: "row",
                    gap: "8px",
                    alignItems: "center",
                    padding: "8px 12px 8px 12px",
                    height: "36px",
                    maxWidth: "448px",
                    backgroundColor: "rgba(253, 253, 252, 1)",
                    borderRadius: "8px"
                  },
                  children: [((_w$selectShowIcon7 = w.selectShowIcon7) !== null && _w$selectShowIcon7 !== void 0 ? _w$selectShowIcon7 : false) ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                    style: {
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "16px",
                      maxWidth: "100%",
                      height: "16px"
                    },
                    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                      style: {
                        alignSelf: "stretch",
                        flexGrow: "1",
                        flexBasis: "0",
                        minHeight: "0"
                      },
                      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                        style: {
                          backgroundColor: "rgba(217, 217, 217, 1)"
                        }
                      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                        style: {
                          backgroundColor: "rgba(142, 138, 131, 1)"
                        }
                      })]
                    })
                  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                    style: {
                      color: "rgba(28, 25, 23, 1)",
                      fontFamily: "Inter",
                      fontSize: "14px",
                      fontWeight: "400",
                      lineHeight: "20px"
                    },
                    children: (_w$selectPlaceholder7 = w.selectPlaceholder7) !== null && _w$selectPlaceholder7 !== void 0 ? _w$selectPlaceholder7 : "Editor"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
                    src: "data:image/svg+xml,%3Csvg%20width%3D%2216%22%20height%3D%2216%22%20viewBox%3D%220%200%2016%2016%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%3Cg%20clip-path%3D%22url(%23clip0_0_844)%22%3E%0A%3Cpath%20d%3D%22M4%206L8%2010L12%206%22%20stroke-width%3D%221.33%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%20stroke%3D%22%238E8A83%22%2F%3E%0A%3C%2Fg%3E%0A%3Cdefs%3E%0A%3CclipPath%20id%3D%22clip0_0_844%22%3E%0A%3Crect%20width%3D%2216%22%20height%3D%2216%22%20fill%3D%22white%22%2F%3E%0A%3C%2FclipPath%3E%0A%3C%2Fdefs%3E%0A%3C%2Fsvg%3E",
                    alt: "Icon Placeholder",
                    style: {
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "16px",
                      maxWidth: "100%",
                      height: "16px"
                    }
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                  style: {
                    display: "flex",
                    flexDirection: "row",
                    gap: "8px",
                    alignItems: "center",
                    padding: "8px 12px 8px 12px",
                    height: "36px",
                    maxWidth: "448px",
                    backgroundColor: "rgba(253, 253, 252, 1)",
                    borderRadius: "8px"
                  },
                  children: [((_w$selectShowIcon8 = w.selectShowIcon8) !== null && _w$selectShowIcon8 !== void 0 ? _w$selectShowIcon8 : false) ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                    style: {
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "16px",
                      maxWidth: "100%",
                      height: "16px"
                    },
                    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                      style: {
                        alignSelf: "stretch",
                        flexGrow: "1",
                        flexBasis: "0",
                        minHeight: "0"
                      },
                      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                        style: {
                          backgroundColor: "rgba(217, 217, 217, 1)"
                        }
                      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                        style: {
                          backgroundColor: "rgba(142, 138, 131, 1)"
                        }
                      })]
                    })
                  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                    style: {
                      flexGrow: "1",
                      flexBasis: "auto",
                      minWidth: "0",
                      color: "rgba(28, 25, 23, 1)",
                      fontFamily: "Inter",
                      fontSize: "14px",
                      fontWeight: "400",
                      lineHeight: "20px"
                    },
                    children: (_w$selectPlaceholder8 = w.selectPlaceholder8) !== null && _w$selectPlaceholder8 !== void 0 ? _w$selectPlaceholder8 : "Owner"
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                  style: {
                    display: "flex",
                    flexDirection: "row",
                    gap: "8px",
                    alignItems: "center",
                    padding: "8px 12px 8px 12px",
                    height: "36px",
                    maxWidth: "448px",
                    backgroundColor: "rgba(253, 253, 252, 1)",
                    borderRadius: "8px"
                  },
                  children: [((_w$selectShowIcon9 = w.selectShowIcon9) !== null && _w$selectShowIcon9 !== void 0 ? _w$selectShowIcon9 : false) ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                    style: {
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "16px",
                      maxWidth: "100%",
                      height: "16px"
                    },
                    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                      style: {
                        alignSelf: "stretch",
                        flexGrow: "1",
                        flexBasis: "0",
                        minHeight: "0"
                      },
                      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                        style: {
                          backgroundColor: "rgba(217, 217, 217, 1)"
                        }
                      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                        style: {
                          backgroundColor: "rgba(142, 138, 131, 1)"
                        }
                      })]
                    })
                  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                    style: {
                      flexGrow: "1",
                      flexBasis: "auto",
                      minWidth: "0",
                      color: "rgba(28, 25, 23, 1)",
                      fontFamily: "Inter",
                      fontSize: "14px",
                      fontWeight: "400",
                      lineHeight: "20px"
                    },
                    children: (_w$selectPlaceholder9 = w.selectPlaceholder9) !== null && _w$selectPlaceholder9 !== void 0 ? _w$selectPlaceholder9 : "Viewer"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
                    src: "data:image/svg+xml,%3Csvg%20width%3D%2216%22%20height%3D%2216%22%20viewBox%3D%220%200%2016%2016%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%3Cg%20clip-path%3D%22url(%23clip0_0_862)%22%3E%0A%3Cpath%20d%3D%22M4%206L8%2010L12%206%22%20stroke-width%3D%221.33%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%20stroke%3D%22%238E8A83%22%2F%3E%0A%3C%2Fg%3E%0A%3Cdefs%3E%0A%3CclipPath%20id%3D%22clip0_0_862%22%3E%0A%3Crect%20width%3D%2216%22%20height%3D%2216%22%20fill%3D%22white%22%2F%3E%0A%3C%2FclipPath%3E%0A%3C%2Fdefs%3E%0A%3C%2Fsvg%3E",
                    alt: "Icon Placeholder",
                    style: {
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "16px",
                      maxWidth: "100%",
                      height: "16px"
                    }
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                  style: {
                    display: "flex",
                    flexDirection: "row",
                    gap: "8px",
                    alignItems: "center",
                    padding: "8px 12px 8px 12px",
                    height: "36px",
                    maxWidth: "448px",
                    backgroundColor: "rgba(253, 253, 252, 1)",
                    borderRadius: "8px"
                  },
                  children: [((_w$selectShowIcon0 = w.selectShowIcon10) !== null && _w$selectShowIcon0 !== void 0 ? _w$selectShowIcon0 : false) ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                    style: {
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "16px",
                      maxWidth: "100%",
                      height: "16px"
                    },
                    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                      style: {
                        alignSelf: "stretch",
                        flexGrow: "1",
                        flexBasis: "0",
                        minHeight: "0"
                      },
                      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                        style: {
                          backgroundColor: "rgba(217, 217, 217, 1)"
                        }
                      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                        style: {
                          backgroundColor: "rgba(142, 138, 131, 1)"
                        }
                      })]
                    })
                  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                    style: {
                      flexGrow: "1",
                      flexBasis: "auto",
                      minWidth: "0",
                      color: "rgba(28, 25, 23, 1)",
                      fontFamily: "Inter",
                      fontSize: "14px",
                      fontWeight: "400",
                      lineHeight: "20px"
                    },
                    children: (_w$selectPlaceholder0 = w.selectPlaceholder10) !== null && _w$selectPlaceholder0 !== void 0 ? _w$selectPlaceholder0 : "Editor"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
                    src: "data:image/svg+xml,%3Csvg%20width%3D%2216%22%20height%3D%2216%22%20viewBox%3D%220%200%2016%2016%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%3Cg%20clip-path%3D%22url(%23clip0_0_871)%22%3E%0A%3Cpath%20d%3D%22M4%206L8%2010L12%206%22%20stroke-width%3D%221.33%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%20stroke%3D%22%238E8A83%22%2F%3E%0A%3C%2Fg%3E%0A%3Cdefs%3E%0A%3CclipPath%20id%3D%22clip0_0_871%22%3E%0A%3Crect%20width%3D%2216%22%20height%3D%2216%22%20fill%3D%22white%22%2F%3E%0A%3C%2FclipPath%3E%0A%3C%2Fdefs%3E%0A%3C%2Fsvg%3E",
                    alt: "Icon Placeholder",
                    style: {
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "16px",
                      maxWidth: "100%",
                      height: "16px"
                    }
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                  style: {
                    display: "flex",
                    flexDirection: "row",
                    gap: "8px",
                    alignItems: "center",
                    padding: "8px 12px 8px 12px",
                    height: "36px",
                    maxWidth: "448px",
                    backgroundColor: "rgba(253, 253, 252, 1)",
                    borderRadius: "8px"
                  },
                  children: [((_w$selectShowIcon1 = w.selectShowIcon11) !== null && _w$selectShowIcon1 !== void 0 ? _w$selectShowIcon1 : false) ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                    style: {
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "16px",
                      maxWidth: "100%",
                      height: "16px"
                    },
                    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                      style: {
                        alignSelf: "stretch",
                        flexGrow: "1",
                        flexBasis: "0",
                        minHeight: "0"
                      },
                      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                        style: {
                          backgroundColor: "rgba(217, 217, 217, 1)"
                        }
                      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                        style: {
                          backgroundColor: "rgba(142, 138, 131, 1)"
                        }
                      })]
                    })
                  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                    style: {
                      flexGrow: "1",
                      flexBasis: "auto",
                      minWidth: "0",
                      color: "rgba(28, 25, 23, 1)",
                      fontFamily: "Inter",
                      fontSize: "14px",
                      fontWeight: "400",
                      lineHeight: "20px"
                    },
                    children: (_w$selectPlaceholder1 = w.selectPlaceholder11) !== null && _w$selectPlaceholder1 !== void 0 ? _w$selectPlaceholder1 : "Viewer"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
                    src: "data:image/svg+xml,%3Csvg%20width%3D%2216%22%20height%3D%2216%22%20viewBox%3D%220%200%2016%2016%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%3Cg%20clip-path%3D%22url(%23clip0_0_880)%22%3E%0A%3Cpath%20d%3D%22M4%206L8%2010L12%206%22%20stroke-width%3D%221.33%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%20stroke%3D%22%238E8A83%22%2F%3E%0A%3C%2Fg%3E%0A%3Cdefs%3E%0A%3CclipPath%20id%3D%22clip0_0_880%22%3E%0A%3Crect%20width%3D%2216%22%20height%3D%2216%22%20fill%3D%22white%22%2F%3E%0A%3C%2FclipPath%3E%0A%3C%2Fdefs%3E%0A%3C%2Fsvg%3E",
                    alt: "Icon Placeholder",
                    style: {
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "16px",
                      maxWidth: "100%",
                      height: "16px"
                    }
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                  style: {
                    display: "flex",
                    flexDirection: "row",
                    gap: "8px",
                    alignItems: "center",
                    padding: "8px 12px 8px 12px",
                    height: "36px",
                    maxWidth: "448px",
                    backgroundColor: "rgba(253, 253, 252, 1)",
                    borderRadius: "8px"
                  },
                  children: [((_w$selectShowIcon10 = w.selectShowIcon12) !== null && _w$selectShowIcon10 !== void 0 ? _w$selectShowIcon10 : false) ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                    style: {
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "16px",
                      maxWidth: "100%",
                      height: "16px"
                    },
                    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                      style: {
                        alignSelf: "stretch",
                        flexGrow: "1",
                        flexBasis: "0",
                        minHeight: "0"
                      },
                      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                        style: {
                          backgroundColor: "rgba(217, 217, 217, 1)"
                        }
                      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                        style: {
                          backgroundColor: "rgba(142, 138, 131, 1)"
                        }
                      })]
                    })
                  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                    style: {
                      flexGrow: "1",
                      flexBasis: "auto",
                      minWidth: "0",
                      color: "rgba(28, 25, 23, 1)",
                      fontFamily: "Inter",
                      fontSize: "14px",
                      fontWeight: "400",
                      lineHeight: "20px"
                    },
                    children: (_w$selectPlaceholder10 = w.selectPlaceholder12) !== null && _w$selectPlaceholder10 !== void 0 ? _w$selectPlaceholder10 : "Viewer"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
                    src: "data:image/svg+xml,%3Csvg%20width%3D%2216%22%20height%3D%2216%22%20viewBox%3D%220%200%2016%2016%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%3Cg%20clip-path%3D%22url(%23clip0_0_889)%22%3E%0A%3Cpath%20d%3D%22M4%206L8%2010L12%206%22%20stroke-width%3D%221.33%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%20stroke%3D%22%238E8A83%22%2F%3E%0A%3C%2Fg%3E%0A%3Cdefs%3E%0A%3CclipPath%20id%3D%22clip0_0_889%22%3E%0A%3Crect%20width%3D%2216%22%20height%3D%2216%22%20fill%3D%22white%22%2F%3E%0A%3C%2FclipPath%3E%0A%3C%2Fdefs%3E%0A%3C%2Fsvg%3E",
                    alt: "Icon Placeholder",
                    style: {
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "16px",
                      maxWidth: "100%",
                      height: "16px"
                    }
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                  style: {
                    display: "flex",
                    flexDirection: "row",
                    gap: "8px",
                    alignItems: "center",
                    padding: "8px 12px 8px 12px",
                    height: "36px",
                    maxWidth: "448px",
                    backgroundColor: "rgba(253, 253, 252, 1)",
                    borderRadius: "8px"
                  },
                  children: [((_w$selectShowIcon11 = w.selectShowIcon13) !== null && _w$selectShowIcon11 !== void 0 ? _w$selectShowIcon11 : false) ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                    style: {
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "16px",
                      maxWidth: "100%",
                      height: "16px"
                    },
                    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                      style: {
                        alignSelf: "stretch",
                        flexGrow: "1",
                        flexBasis: "0",
                        minHeight: "0"
                      },
                      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                        style: {
                          backgroundColor: "rgba(217, 217, 217, 1)"
                        }
                      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                        style: {
                          backgroundColor: "rgba(142, 138, 131, 1)"
                        }
                      })]
                    })
                  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                    style: {
                      flexGrow: "1",
                      flexBasis: "auto",
                      minWidth: "0",
                      color: "rgba(28, 25, 23, 1)",
                      fontFamily: "Inter",
                      fontSize: "14px",
                      fontWeight: "400",
                      lineHeight: "20px"
                    },
                    children: (_w$selectPlaceholder11 = w.selectPlaceholder13) !== null && _w$selectPlaceholder11 !== void 0 ? _w$selectPlaceholder11 : "Viewer"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
                    src: "data:image/svg+xml,%3Csvg%20width%3D%2216%22%20height%3D%2216%22%20viewBox%3D%220%200%2016%2016%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%3Cg%20clip-path%3D%22url(%23clip0_0_898)%22%3E%0A%3Cpath%20d%3D%22M4%206L8%2010L12%206%22%20stroke-width%3D%221.33%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%20stroke%3D%22%238E8A83%22%2F%3E%0A%3C%2Fg%3E%0A%3Cdefs%3E%0A%3CclipPath%20id%3D%22clip0_0_898%22%3E%0A%3Crect%20width%3D%2216%22%20height%3D%2216%22%20fill%3D%22white%22%2F%3E%0A%3C%2FclipPath%3E%0A%3C%2Fdefs%3E%0A%3C%2Fsvg%3E",
                    alt: "Icon Placeholder",
                    style: {
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "16px",
                      maxWidth: "100%",
                      height: "16px"
                    }
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                  style: {
                    display: "flex",
                    flexDirection: "row",
                    gap: "8px",
                    alignItems: "center",
                    padding: "8px 12px 8px 12px",
                    height: "36px",
                    maxWidth: "448px",
                    backgroundColor: "rgba(253, 253, 252, 1)",
                    borderRadius: "8px"
                  },
                  children: [((_w$selectShowIcon12 = w.selectShowIcon14) !== null && _w$selectShowIcon12 !== void 0 ? _w$selectShowIcon12 : false) ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                    style: {
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "16px",
                      maxWidth: "100%",
                      height: "16px"
                    },
                    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                      style: {
                        alignSelf: "stretch",
                        flexGrow: "1",
                        flexBasis: "0",
                        minHeight: "0"
                      },
                      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                        style: {
                          backgroundColor: "rgba(217, 217, 217, 1)"
                        }
                      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                        style: {
                          backgroundColor: "rgba(142, 138, 131, 1)"
                        }
                      })]
                    })
                  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                    style: {
                      flexGrow: "1",
                      flexBasis: "auto",
                      minWidth: "0",
                      color: "rgba(28, 25, 23, 1)",
                      fontFamily: "Inter",
                      fontSize: "14px",
                      fontWeight: "400",
                      lineHeight: "20px"
                    },
                    children: (_w$selectPlaceholder12 = w.selectPlaceholder14) !== null && _w$selectPlaceholder12 !== void 0 ? _w$selectPlaceholder12 : "Viewer"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
                    src: "data:image/svg+xml,%3Csvg%20width%3D%2216%22%20height%3D%2216%22%20viewBox%3D%220%200%2016%2016%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%3Cg%20clip-path%3D%22url(%23clip0_0_907)%22%3E%0A%3Cpath%20d%3D%22M4%206L8%2010L12%206%22%20stroke-width%3D%221.33%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%20stroke%3D%22%238E8A83%22%2F%3E%0A%3C%2Fg%3E%0A%3Cdefs%3E%0A%3CclipPath%20id%3D%22clip0_0_907%22%3E%0A%3Crect%20width%3D%2216%22%20height%3D%2216%22%20fill%3D%22white%22%2F%3E%0A%3C%2FclipPath%3E%0A%3C%2Fdefs%3E%0A%3C%2Fsvg%3E",
                    alt: "Icon Placeholder",
                    style: {
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "16px",
                      maxWidth: "100%",
                      height: "16px"
                    }
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                  style: {
                    display: "flex",
                    flexDirection: "row",
                    gap: "8px",
                    alignItems: "center",
                    padding: "8px 12px 8px 12px",
                    height: "36px",
                    maxWidth: "448px",
                    backgroundColor: "rgba(253, 253, 252, 1)",
                    borderRadius: "8px"
                  },
                  children: [((_w$selectShowIcon13 = w.selectShowIcon15) !== null && _w$selectShowIcon13 !== void 0 ? _w$selectShowIcon13 : false) ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                    style: {
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "16px",
                      maxWidth: "100%",
                      height: "16px"
                    },
                    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                      style: {
                        alignSelf: "stretch",
                        flexGrow: "1",
                        flexBasis: "0",
                        minHeight: "0"
                      },
                      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                        style: {
                          backgroundColor: "rgba(217, 217, 217, 1)"
                        }
                      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                        style: {
                          backgroundColor: "rgba(142, 138, 131, 1)"
                        }
                      })]
                    })
                  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                    style: {
                      flexGrow: "1",
                      flexBasis: "auto",
                      minWidth: "0",
                      color: "rgba(28, 25, 23, 1)",
                      fontFamily: "Inter",
                      fontSize: "14px",
                      fontWeight: "400",
                      lineHeight: "20px"
                    },
                    children: (_w$selectPlaceholder13 = w.selectPlaceholder15) !== null && _w$selectPlaceholder13 !== void 0 ? _w$selectPlaceholder13 : "Viewer"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
                    src: "data:image/svg+xml,%3Csvg%20width%3D%2216%22%20height%3D%2216%22%20viewBox%3D%220%200%2016%2016%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%3Cg%20clip-path%3D%22url(%23clip0_0_916)%22%3E%0A%3Cpath%20d%3D%22M4%206L8%2010L12%206%22%20stroke-width%3D%221.33%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%20stroke%3D%22%238E8A83%22%2F%3E%0A%3C%2Fg%3E%0A%3Cdefs%3E%0A%3CclipPath%20id%3D%22clip0_0_916%22%3E%0A%3Crect%20width%3D%2216%22%20height%3D%2216%22%20fill%3D%22white%22%2F%3E%0A%3C%2FclipPath%3E%0A%3C%2Fdefs%3E%0A%3C%2Fsvg%3E",
                    alt: "Icon Placeholder",
                    style: {
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "16px",
                      maxWidth: "100%",
                      height: "16px"
                    }
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                  style: {
                    display: "flex",
                    flexDirection: "row",
                    gap: "8px",
                    alignItems: "center",
                    padding: "8px 12px 8px 12px",
                    height: "36px",
                    maxWidth: "448px",
                    backgroundColor: "rgba(253, 253, 252, 1)",
                    borderRadius: "8px"
                  },
                  children: [((_w$selectShowIcon14 = w.selectShowIcon16) !== null && _w$selectShowIcon14 !== void 0 ? _w$selectShowIcon14 : false) ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                    style: {
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "16px",
                      maxWidth: "100%",
                      height: "16px"
                    },
                    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                      style: {
                        alignSelf: "stretch",
                        flexGrow: "1",
                        flexBasis: "0",
                        minHeight: "0"
                      },
                      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                        style: {
                          backgroundColor: "rgba(217, 217, 217, 1)"
                        }
                      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                        style: {
                          backgroundColor: "rgba(142, 138, 131, 1)"
                        }
                      })]
                    })
                  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                    style: {
                      flexGrow: "1",
                      flexBasis: "auto",
                      minWidth: "0",
                      color: "rgba(28, 25, 23, 1)",
                      fontFamily: "Inter",
                      fontSize: "14px",
                      fontWeight: "400",
                      lineHeight: "20px"
                    },
                    children: (_w$selectPlaceholder14 = w.selectPlaceholder16) !== null && _w$selectPlaceholder14 !== void 0 ? _w$selectPlaceholder14 : "Viewer"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
                    src: "data:image/svg+xml,%3Csvg%20width%3D%2216%22%20height%3D%2216%22%20viewBox%3D%220%200%2016%2016%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%3Cg%20clip-path%3D%22url(%23clip0_0_925)%22%3E%0A%3Cpath%20d%3D%22M4%206L8%2010L12%206%22%20stroke-width%3D%221.33%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%20stroke%3D%22%238E8A83%22%2F%3E%0A%3C%2Fg%3E%0A%3Cdefs%3E%0A%3CclipPath%20id%3D%22clip0_0_925%22%3E%0A%3Crect%20width%3D%2216%22%20height%3D%2216%22%20fill%3D%22white%22%2F%3E%0A%3C%2FclipPath%3E%0A%3C%2Fdefs%3E%0A%3C%2Fsvg%3E",
                    alt: "Icon Placeholder",
                    style: {
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "16px",
                      maxWidth: "100%",
                      height: "16px"
                    }
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                  style: {
                    display: "flex",
                    flexDirection: "row",
                    gap: "8px",
                    alignItems: "center",
                    padding: "8px 12px 8px 12px",
                    height: "36px",
                    maxWidth: "448px",
                    backgroundColor: "rgba(253, 253, 252, 1)",
                    borderRadius: "8px"
                  },
                  children: [((_w$selectShowIcon15 = w.selectShowIcon17) !== null && _w$selectShowIcon15 !== void 0 ? _w$selectShowIcon15 : false) ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                    style: {
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "16px",
                      maxWidth: "100%",
                      height: "16px"
                    },
                    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                      style: {
                        alignSelf: "stretch",
                        flexGrow: "1",
                        flexBasis: "0",
                        minHeight: "0"
                      },
                      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                        style: {
                          backgroundColor: "rgba(217, 217, 217, 1)"
                        }
                      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                        style: {
                          backgroundColor: "rgba(142, 138, 131, 1)"
                        }
                      })]
                    })
                  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                    style: {
                      flexGrow: "1",
                      flexBasis: "auto",
                      minWidth: "0",
                      color: "rgba(28, 25, 23, 1)",
                      fontFamily: "Inter",
                      fontSize: "14px",
                      fontWeight: "400",
                      lineHeight: "20px"
                    },
                    children: (_w$selectPlaceholder15 = w.selectPlaceholder17) !== null && _w$selectPlaceholder15 !== void 0 ? _w$selectPlaceholder15 : "Viewer"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
                    src: "data:image/svg+xml,%3Csvg%20width%3D%2216%22%20height%3D%2216%22%20viewBox%3D%220%200%2016%2016%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%3Cg%20clip-path%3D%22url(%23clip0_0_934)%22%3E%0A%3Cpath%20d%3D%22M4%206L8%2010L12%206%22%20stroke-width%3D%221.33%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%20stroke%3D%22%238E8A83%22%2F%3E%0A%3C%2Fg%3E%0A%3Cdefs%3E%0A%3CclipPath%20id%3D%22clip0_0_934%22%3E%0A%3Crect%20width%3D%2216%22%20height%3D%2216%22%20fill%3D%22white%22%2F%3E%0A%3C%2FclipPath%3E%0A%3C%2Fdefs%3E%0A%3C%2Fsvg%3E",
                    alt: "Icon Placeholder",
                    style: {
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "16px",
                      maxWidth: "100%",
                      height: "16px"
                    }
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                  style: {
                    display: "flex",
                    flexDirection: "row",
                    gap: "8px",
                    alignItems: "center",
                    padding: "8px 12px 8px 12px",
                    height: "36px",
                    maxWidth: "448px",
                    backgroundColor: "rgba(253, 253, 252, 1)",
                    borderRadius: "8px"
                  },
                  children: [((_w$selectShowIcon16 = w.selectShowIcon18) !== null && _w$selectShowIcon16 !== void 0 ? _w$selectShowIcon16 : false) ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                    style: {
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "16px",
                      maxWidth: "100%",
                      height: "16px"
                    },
                    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                      style: {
                        alignSelf: "stretch",
                        flexGrow: "1",
                        flexBasis: "0",
                        minHeight: "0"
                      },
                      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                        style: {
                          backgroundColor: "rgba(217, 217, 217, 1)"
                        }
                      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                        style: {
                          backgroundColor: "rgba(142, 138, 131, 1)"
                        }
                      })]
                    })
                  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                    style: {
                      flexGrow: "1",
                      flexBasis: "auto",
                      minWidth: "0",
                      color: "rgba(28, 25, 23, 1)",
                      fontFamily: "Inter",
                      fontSize: "14px",
                      fontWeight: "400",
                      lineHeight: "20px"
                    },
                    children: (_w$selectPlaceholder16 = w.selectPlaceholder18) !== null && _w$selectPlaceholder16 !== void 0 ? _w$selectPlaceholder16 : "Viewer"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
                    src: "data:image/svg+xml,%3Csvg%20width%3D%2216%22%20height%3D%2216%22%20viewBox%3D%220%200%2016%2016%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%3Cg%20clip-path%3D%22url(%23clip0_0_943)%22%3E%0A%3Cpath%20d%3D%22M4%206L8%2010L12%206%22%20stroke-width%3D%221.33%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%20stroke%3D%22%238E8A83%22%2F%3E%0A%3C%2Fg%3E%0A%3Cdefs%3E%0A%3CclipPath%20id%3D%22clip0_0_943%22%3E%0A%3Crect%20width%3D%2216%22%20height%3D%2216%22%20fill%3D%22white%22%2F%3E%0A%3C%2FclipPath%3E%0A%3C%2Fdefs%3E%0A%3C%2Fsvg%3E",
                    alt: "Icon Placeholder",
                    style: {
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "16px",
                      maxWidth: "100%",
                      height: "16px"
                    }
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                  style: {
                    display: "flex",
                    flexDirection: "row",
                    gap: "8px",
                    alignItems: "center",
                    padding: "8px 12px 8px 12px",
                    height: "36px",
                    maxWidth: "448px",
                    backgroundColor: "rgba(253, 253, 252, 1)",
                    borderRadius: "8px"
                  },
                  children: [((_w$selectShowIcon17 = w.selectShowIcon19) !== null && _w$selectShowIcon17 !== void 0 ? _w$selectShowIcon17 : false) ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                    style: {
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "16px",
                      maxWidth: "100%",
                      height: "16px"
                    },
                    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                      style: {
                        alignSelf: "stretch",
                        flexGrow: "1",
                        flexBasis: "0",
                        minHeight: "0"
                      },
                      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                        style: {
                          backgroundColor: "rgba(217, 217, 217, 1)"
                        }
                      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                        style: {
                          backgroundColor: "rgba(142, 138, 131, 1)"
                        }
                      })]
                    })
                  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                    style: {
                      flexGrow: "1",
                      flexBasis: "auto",
                      minWidth: "0",
                      color: "rgba(28, 25, 23, 1)",
                      fontFamily: "Inter",
                      fontSize: "14px",
                      fontWeight: "400",
                      lineHeight: "20px"
                    },
                    children: (_w$selectPlaceholder17 = w.selectPlaceholder19) !== null && _w$selectPlaceholder17 !== void 0 ? _w$selectPlaceholder17 : "Viewer"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
                    src: "data:image/svg+xml,%3Csvg%20width%3D%2216%22%20height%3D%2216%22%20viewBox%3D%220%200%2016%2016%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%3Cg%20clip-path%3D%22url(%23clip0_0_952)%22%3E%0A%3Cpath%20d%3D%22M4%206L8%2010L12%206%22%20stroke-width%3D%221.33%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%20stroke%3D%22%238E8A83%22%2F%3E%0A%3C%2Fg%3E%0A%3Cdefs%3E%0A%3CclipPath%20id%3D%22clip0_0_952%22%3E%0A%3Crect%20width%3D%2216%22%20height%3D%2216%22%20fill%3D%22white%22%2F%3E%0A%3C%2FclipPath%3E%0A%3C%2Fdefs%3E%0A%3C%2Fsvg%3E",
                    alt: "Icon Placeholder",
                    style: {
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "16px",
                      maxWidth: "100%",
                      height: "16px"
                    }
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                  style: {
                    display: "flex",
                    flexDirection: "row",
                    gap: "8px",
                    alignItems: "center",
                    padding: "8px 8px 8px 8px"
                  },
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_avatar.Avatar, _objectSpread(_objectSpread({}, w.avatar12), {}, {
                    size: "default",
                    "data-variant": "fallback",
                    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                      style: {
                        color: "rgba(63, 60, 56, 1)",
                        fontFamily: "Inter",
                        fontSize: "12px",
                        fontWeight: "400",
                        lineHeight: "20px",
                        textAlign: "center"
                      },
                      children: (_w$avatarFallbackText8 = w.avatarFallbackText8) !== null && _w$avatarFallbackText8 !== void 0 ? _w$avatarFallbackText8 : "ST"
                    }), ((_w$avatarShowBadge10 = w.avatarShowBadge12) !== null && _w$avatarShowBadge10 !== void 0 ? _w$avatarShowBadge10 : false) ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_avatar.AvatarBadge, _objectSpread(_objectSpread({}, w.avatarBadge12), {}, {
                      "data-type": "color"
                    })) : null]
                  })), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                    style: {
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "flex-start"
                    },
                    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                      style: {
                        display: "flex",
                        flexDirection: "row",
                        gap: "4px",
                        alignItems: "center",
                        alignSelf: "stretch"
                      },
                      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                        style: {
                          color: "rgba(28, 25, 23, 1)",
                          fontFamily: "Inter",
                          fontSize: "14px",
                          fontWeight: "500",
                          lineHeight: "20px"
                        },
                        children: (_w$profileCardName10 = w.profileCardName12) !== null && _w$profileCardName10 !== void 0 ? _w$profileCardName10 : "Sophie Tan"
                      })
                    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                      style: {
                        alignSelf: "stretch",
                        color: "rgba(142, 138, 131, 1)",
                        fontFamily: "Inter",
                        fontSize: "12px",
                        fontWeight: "400",
                        lineHeight: "16px",
                        letterSpacing: "0.12px"
                      },
                      children: (_w$profileCardBody10 = w.profileCardBody12) !== null && _w$profileCardBody10 !== void 0 ? _w$profileCardBody10 : "sophie.tan@acme.com"
                    })]
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                  style: {
                    display: "flex",
                    flexDirection: "row",
                    gap: "8px",
                    alignItems: "center",
                    padding: "8px 8px 8px 8px"
                  },
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_avatar.Avatar, _objectSpread(_objectSpread({}, w.avatar13), {}, {
                    size: "default",
                    "data-variant": "fallback",
                    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                      style: {
                        color: "rgba(63, 60, 56, 1)",
                        fontFamily: "Inter",
                        fontSize: "12px",
                        fontWeight: "400",
                        lineHeight: "20px",
                        textAlign: "center"
                      },
                      children: (_w$avatarFallbackText9 = w.avatarFallbackText9) !== null && _w$avatarFallbackText9 !== void 0 ? _w$avatarFallbackText9 : "ST"
                    }), ((_w$avatarShowBadge11 = w.avatarShowBadge13) !== null && _w$avatarShowBadge11 !== void 0 ? _w$avatarShowBadge11 : false) ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_avatar.AvatarBadge, _objectSpread(_objectSpread({}, w.avatarBadge13), {}, {
                      "data-type": "color"
                    })) : null]
                  })), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                    style: {
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "flex-start"
                    },
                    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                      style: {
                        display: "flex",
                        flexDirection: "row",
                        gap: "4px",
                        alignItems: "center",
                        alignSelf: "stretch"
                      },
                      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                        style: {
                          color: "rgba(28, 25, 23, 1)",
                          fontFamily: "Inter",
                          fontSize: "14px",
                          fontWeight: "500",
                          lineHeight: "20px"
                        },
                        children: (_w$profileCardName11 = w.profileCardName13) !== null && _w$profileCardName11 !== void 0 ? _w$profileCardName11 : "Sophie Tan"
                      })
                    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                      style: {
                        alignSelf: "stretch",
                        color: "rgba(142, 138, 131, 1)",
                        fontFamily: "Inter",
                        fontSize: "12px",
                        fontWeight: "400",
                        lineHeight: "16px",
                        letterSpacing: "0.12px"
                      },
                      children: (_w$profileCardBody11 = w.profileCardBody13) !== null && _w$profileCardBody11 !== void 0 ? _w$profileCardBody11 : "sophie.tan@acme.com"
                    })]
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                  style: {
                    display: "flex",
                    flexDirection: "row",
                    gap: "8px",
                    alignItems: "center",
                    padding: "8px 8px 8px 8px"
                  },
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_avatar.Avatar, _objectSpread(_objectSpread({}, w.avatar14), {}, {
                    size: "default",
                    "data-variant": "fallback",
                    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                      style: {
                        color: "rgba(63, 60, 56, 1)",
                        fontFamily: "Inter",
                        fontSize: "12px",
                        fontWeight: "400",
                        lineHeight: "20px",
                        textAlign: "center"
                      },
                      children: (_w$avatarFallbackText0 = w.avatarFallbackText10) !== null && _w$avatarFallbackText0 !== void 0 ? _w$avatarFallbackText0 : "ST"
                    }), ((_w$avatarShowBadge12 = w.avatarShowBadge14) !== null && _w$avatarShowBadge12 !== void 0 ? _w$avatarShowBadge12 : false) ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_avatar.AvatarBadge, _objectSpread(_objectSpread({}, w.avatarBadge14), {}, {
                      "data-type": "color"
                    })) : null]
                  })), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                    style: {
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "flex-start"
                    },
                    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                      style: {
                        display: "flex",
                        flexDirection: "row",
                        gap: "4px",
                        alignItems: "center",
                        alignSelf: "stretch"
                      },
                      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                        style: {
                          color: "rgba(28, 25, 23, 1)",
                          fontFamily: "Inter",
                          fontSize: "14px",
                          fontWeight: "500",
                          lineHeight: "20px"
                        },
                        children: (_w$profileCardName12 = w.profileCardName14) !== null && _w$profileCardName12 !== void 0 ? _w$profileCardName12 : "Sophie Tan"
                      })
                    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                      style: {
                        alignSelf: "stretch",
                        color: "rgba(142, 138, 131, 1)",
                        fontFamily: "Inter",
                        fontSize: "12px",
                        fontWeight: "400",
                        lineHeight: "16px",
                        letterSpacing: "0.12px"
                      },
                      children: (_w$profileCardBody12 = w.profileCardBody14) !== null && _w$profileCardBody12 !== void 0 ? _w$profileCardBody12 : "sophie.tan@acme.com"
                    })]
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                  style: {
                    display: "flex",
                    flexDirection: "row",
                    gap: "8px",
                    alignItems: "center",
                    padding: "8px 8px 8px 8px"
                  },
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_avatar.Avatar, _objectSpread(_objectSpread({}, w.avatar15), {}, {
                    size: "default",
                    "data-variant": "fallback",
                    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                      style: {
                        color: "rgba(63, 60, 56, 1)",
                        fontFamily: "Inter",
                        fontSize: "12px",
                        fontWeight: "400",
                        lineHeight: "20px",
                        textAlign: "center"
                      },
                      children: (_w$avatarFallbackText1 = w.avatarFallbackText11) !== null && _w$avatarFallbackText1 !== void 0 ? _w$avatarFallbackText1 : "ST"
                    }), ((_w$avatarShowBadge13 = w.avatarShowBadge15) !== null && _w$avatarShowBadge13 !== void 0 ? _w$avatarShowBadge13 : false) ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_avatar.AvatarBadge, _objectSpread(_objectSpread({}, w.avatarBadge15), {}, {
                      "data-type": "color"
                    })) : null]
                  })), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                    style: {
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "flex-start"
                    },
                    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                      style: {
                        display: "flex",
                        flexDirection: "row",
                        gap: "4px",
                        alignItems: "center",
                        alignSelf: "stretch"
                      },
                      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                        style: {
                          color: "rgba(28, 25, 23, 1)",
                          fontFamily: "Inter",
                          fontSize: "14px",
                          fontWeight: "500",
                          lineHeight: "20px"
                        },
                        children: (_w$profileCardName13 = w.profileCardName15) !== null && _w$profileCardName13 !== void 0 ? _w$profileCardName13 : "Sophie Tan"
                      })
                    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                      style: {
                        alignSelf: "stretch",
                        color: "rgba(142, 138, 131, 1)",
                        fontFamily: "Inter",
                        fontSize: "12px",
                        fontWeight: "400",
                        lineHeight: "16px",
                        letterSpacing: "0.12px"
                      },
                      children: (_w$profileCardBody13 = w.profileCardBody15) !== null && _w$profileCardBody13 !== void 0 ? _w$profileCardBody13 : "sophie.tan@acme.com"
                    })]
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                  style: {
                    display: "flex",
                    flexDirection: "row",
                    gap: "8px",
                    alignItems: "center",
                    padding: "8px 8px 8px 8px"
                  },
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_avatar.Avatar, _objectSpread(_objectSpread({}, w.avatar16), {}, {
                    size: "default",
                    "data-variant": "fallback",
                    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                      style: {
                        color: "rgba(63, 60, 56, 1)",
                        fontFamily: "Inter",
                        fontSize: "12px",
                        fontWeight: "400",
                        lineHeight: "20px",
                        textAlign: "center"
                      },
                      children: (_w$avatarFallbackText10 = w.avatarFallbackText12) !== null && _w$avatarFallbackText10 !== void 0 ? _w$avatarFallbackText10 : "ST"
                    }), ((_w$avatarShowBadge14 = w.avatarShowBadge16) !== null && _w$avatarShowBadge14 !== void 0 ? _w$avatarShowBadge14 : false) ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_avatar.AvatarBadge, _objectSpread(_objectSpread({}, w.avatarBadge16), {}, {
                      "data-type": "color"
                    })) : null]
                  })), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                    style: {
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "flex-start"
                    },
                    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                      style: {
                        display: "flex",
                        flexDirection: "row",
                        gap: "4px",
                        alignItems: "center",
                        alignSelf: "stretch"
                      },
                      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                        style: {
                          color: "rgba(28, 25, 23, 1)",
                          fontFamily: "Inter",
                          fontSize: "14px",
                          fontWeight: "500",
                          lineHeight: "20px"
                        },
                        children: (_w$profileCardName14 = w.profileCardName16) !== null && _w$profileCardName14 !== void 0 ? _w$profileCardName14 : "Sophie Tan"
                      })
                    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                      style: {
                        alignSelf: "stretch",
                        color: "rgba(142, 138, 131, 1)",
                        fontFamily: "Inter",
                        fontSize: "12px",
                        fontWeight: "400",
                        lineHeight: "16px",
                        letterSpacing: "0.12px"
                      },
                      children: (_w$profileCardBody14 = w.profileCardBody16) !== null && _w$profileCardBody14 !== void 0 ? _w$profileCardBody14 : "sophie.tan@acme.com"
                    })]
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                  style: {
                    display: "flex",
                    flexDirection: "row",
                    gap: "8px",
                    alignItems: "center",
                    padding: "8px 8px 8px 8px"
                  },
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_avatar.Avatar, _objectSpread(_objectSpread({}, w.avatar17), {}, {
                    size: "default",
                    "data-variant": "fallback",
                    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                      style: {
                        color: "rgba(63, 60, 56, 1)",
                        fontFamily: "Inter",
                        fontSize: "12px",
                        fontWeight: "400",
                        lineHeight: "20px",
                        textAlign: "center"
                      },
                      children: (_w$avatarFallbackText11 = w.avatarFallbackText13) !== null && _w$avatarFallbackText11 !== void 0 ? _w$avatarFallbackText11 : "ST"
                    }), ((_w$avatarShowBadge15 = w.avatarShowBadge17) !== null && _w$avatarShowBadge15 !== void 0 ? _w$avatarShowBadge15 : false) ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_avatar.AvatarBadge, _objectSpread(_objectSpread({}, w.avatarBadge17), {}, {
                      "data-type": "color"
                    })) : null]
                  })), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                    style: {
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "flex-start"
                    },
                    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                      style: {
                        display: "flex",
                        flexDirection: "row",
                        gap: "4px",
                        alignItems: "center",
                        alignSelf: "stretch"
                      },
                      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                        style: {
                          color: "rgba(28, 25, 23, 1)",
                          fontFamily: "Inter",
                          fontSize: "14px",
                          fontWeight: "500",
                          lineHeight: "20px"
                        },
                        children: (_w$profileCardName15 = w.profileCardName17) !== null && _w$profileCardName15 !== void 0 ? _w$profileCardName15 : "Sophie Tan"
                      })
                    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                      style: {
                        alignSelf: "stretch",
                        color: "rgba(142, 138, 131, 1)",
                        fontFamily: "Inter",
                        fontSize: "12px",
                        fontWeight: "400",
                        lineHeight: "16px",
                        letterSpacing: "0.12px"
                      },
                      children: (_w$profileCardBody15 = w.profileCardBody17) !== null && _w$profileCardBody15 !== void 0 ? _w$profileCardBody15 : "sophie.tan@acme.com"
                    })]
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                  style: {
                    display: "flex",
                    flexDirection: "row",
                    gap: "8px",
                    alignItems: "center",
                    padding: "8px 8px 8px 8px"
                  },
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_avatar.Avatar, _objectSpread(_objectSpread({}, w.avatar18), {}, {
                    size: "default",
                    "data-variant": "fallback",
                    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                      style: {
                        color: "rgba(63, 60, 56, 1)",
                        fontFamily: "Inter",
                        fontSize: "12px",
                        fontWeight: "400",
                        lineHeight: "20px",
                        textAlign: "center"
                      },
                      children: (_w$avatarFallbackText12 = w.avatarFallbackText14) !== null && _w$avatarFallbackText12 !== void 0 ? _w$avatarFallbackText12 : "ST"
                    }), ((_w$avatarShowBadge16 = w.avatarShowBadge18) !== null && _w$avatarShowBadge16 !== void 0 ? _w$avatarShowBadge16 : false) ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_avatar.AvatarBadge, _objectSpread(_objectSpread({}, w.avatarBadge18), {}, {
                      "data-type": "color"
                    })) : null]
                  })), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                    style: {
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "flex-start"
                    },
                    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                      style: {
                        display: "flex",
                        flexDirection: "row",
                        gap: "4px",
                        alignItems: "center",
                        alignSelf: "stretch"
                      },
                      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                        style: {
                          color: "rgba(28, 25, 23, 1)",
                          fontFamily: "Inter",
                          fontSize: "14px",
                          fontWeight: "500",
                          lineHeight: "20px"
                        },
                        children: (_w$profileCardName16 = w.profileCardName18) !== null && _w$profileCardName16 !== void 0 ? _w$profileCardName16 : "Sophie Tan"
                      })
                    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                      style: {
                        alignSelf: "stretch",
                        color: "rgba(142, 138, 131, 1)",
                        fontFamily: "Inter",
                        fontSize: "12px",
                        fontWeight: "400",
                        lineHeight: "16px",
                        letterSpacing: "0.12px"
                      },
                      children: (_w$profileCardBody16 = w.profileCardBody18) !== null && _w$profileCardBody16 !== void 0 ? _w$profileCardBody16 : "sophie.tan@acme.com"
                    })]
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                  style: {
                    display: "flex",
                    flexDirection: "row",
                    gap: "8px",
                    alignItems: "center",
                    padding: "8px 8px 8px 8px"
                  },
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_avatar.Avatar, _objectSpread(_objectSpread({}, w.avatar19), {}, {
                    size: "default",
                    "data-variant": "fallback",
                    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                      style: {
                        color: "rgba(63, 60, 56, 1)",
                        fontFamily: "Inter",
                        fontSize: "12px",
                        fontWeight: "400",
                        lineHeight: "20px",
                        textAlign: "center"
                      },
                      children: (_w$avatarFallbackText13 = w.avatarFallbackText15) !== null && _w$avatarFallbackText13 !== void 0 ? _w$avatarFallbackText13 : "ST"
                    }), ((_w$avatarShowBadge17 = w.avatarShowBadge19) !== null && _w$avatarShowBadge17 !== void 0 ? _w$avatarShowBadge17 : false) ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_avatar.AvatarBadge, _objectSpread(_objectSpread({}, w.avatarBadge19), {}, {
                      "data-type": "color"
                    })) : null]
                  })), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                    style: {
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "flex-start"
                    },
                    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                      style: {
                        display: "flex",
                        flexDirection: "row",
                        gap: "4px",
                        alignItems: "center",
                        alignSelf: "stretch"
                      },
                      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                        style: {
                          color: "rgba(28, 25, 23, 1)",
                          fontFamily: "Inter",
                          fontSize: "14px",
                          fontWeight: "500",
                          lineHeight: "20px"
                        },
                        children: (_w$profileCardName17 = w.profileCardName19) !== null && _w$profileCardName17 !== void 0 ? _w$profileCardName17 : "Sophie Tan"
                      })
                    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                      style: {
                        alignSelf: "stretch",
                        color: "rgba(142, 138, 131, 1)",
                        fontFamily: "Inter",
                        fontSize: "12px",
                        fontWeight: "400",
                        lineHeight: "16px",
                        letterSpacing: "0.12px"
                      },
                      children: (_w$profileCardBody17 = w.profileCardBody19) !== null && _w$profileCardBody17 !== void 0 ? _w$profileCardBody17 : "sophie.tan@acme.com"
                    })]
                  })]
                })]
              })]
            })
          })
        })]
      })
    })]
  });
}